"use strict";

export default {
  ACC_CAM_CO: "Pawned",
  ACC_CHI_TIET_TAI_KHOAN: "Account details",
  ACC_CHON_LOAI_TAI_KHOAN: "Select account type",
  ACC_CHON_TAI_KHOAN: "Select account",
  ACC_TAI_KHOAN: "Account",
  ACC_DANG_KY: "Register",
  ACC_DANG_NHAP: "Login",
  ACC_DANG_XUAT: "Logout",
  ACC_DANG_NHAP_BANG_TAI_KHOAN_KHAC: "Login by other account",
  ACC_DEN_HAN: "Due date",
  ACC_DIA_CHI: "Address",
  ACC_DON_VI: "Unit",
  ACC_EMAIL: "Email",
  ACC_FAX: "fax",
  ACC_GOC_TRONG_HAN: "Original in term ",
  ACC_GIOI_TINH: "Gender",
  ACC_GIOI_TINH_NAM: "Male",
  ACC_GIOI_TINH_NU: "Female",
  ACC_HAN_MUC_GD: "Transaction limit",
  ACC_HINH_THUC_MO_SO: "Kind of open desposit ",
  ACC_HOAT_DONG: "Active",
  ACC_KHONG_CO_GIAO_DICH_NAO: "No transactions",
  ACC_KHONG_CO_TAI_KHOAN: "No account",
  ACC_KHONG_HOAT_DONG: "Inactive",
  ACC_KY_HAN: "Term",
  ACC_LAI_SUAT: "Interest Rate",
  ACC_LAI_THAU_CHI: "Overdraft Interest Rate",
  ACC_LAI_CONG_DON: "Accumulate Interest Rate",
  ACC_LOI_CHUA_NHAP_LAI_MAT_KHAU_MOI: "Please enter new password again",
  ACC_LOI_CHUA_NHAP_MAT_KHAU: "Please enter password",
  ACC_LOI_CHUA_NHAP_MAT_KHAU_HIEN_TAI: "Please enter current password",
  ACC_LOI_CHUA_NHAP_MAT_KHAU_MOI: "Please enter new password",
  ACC_LOI_CHUA_NHAP_TAI_KHOAN: "Please enter username",
  ACC_LOI_TAI_KHOAN: "Invalid account",
  ACC_MAN_CHI_TIET_LICH_TRA_NO: "Payment schedule details",
  ACC_MAN_DONG: "Close",
  ACC_MAN_DU_NO_HIEN_TAI: "Current debit balance",
  ACC_MAN_GIA_TRI_TAI_SAN: "Asset value",
  ACC_MAN_GOC: "Origin",
  ACC_MAN_GOC_CON_LAI: "Remaining",
  ACC_MAN_GOC_QUA_HAN: "Principal overdue",
  ACC_MAN_GOC_TRA_LAI: "Principal pays interest",
  ACC_MAN_LAI: "Interest",
  ACC_MAN_LAI_PHAI_TRA: "Interest payable",
  ACC_MAN_LAI_PHAT_TREN_GOC_QUA_HAN: "Penalty interest on overdue principal",
  ACC_MAN_LAI_PHAT_TREN_LAI_QUA_HAN: "Penalty interest on overdue interest",
  ACC_MAN_LAI_QUA_HAN: "Interest overdue",
  ACC_MAN_LICH_SU_TRA_NO: "Payment history",
  ACC_MAN_LOAI_TAI_SAN: "Asset type",
  ACC_MAN_MO_TA_TAI_SAN: "Describe asset",
  ACC_MAN_NGAY_HIEU_LUC: "Effective date",
  ACC_MAN_PHI: "Fee",
  ACC_MAN_SO_KY_CON_LAI: "Number of remaining term",
  ACC_MAN_TAI_KHOAN_VAY: "Loan account",
  ACC_MAN_TAI_SAN_DAM_BAO: "Collateral",
  ACC_MAN_TB_CHON_KHOANG_NGAY_NHO_HON_1_NAM: "Date and time must be within one year",
  ACC_MAN_TB_CHON_NGAY_BAT_DAU_TRUOC_KET_THUC: "End-date must be after begin-date",
  ACC_MAN_THONG_TIN_KHOAN_VAY: "Loan information",
  ACC_MAN_TONG_GOC_LAI: "Total interest",
  ACC_MAN_XEM_TAI_SAN_DAM_BAO: "View collateral",
  ACC_MAT_KHAU_HIEN_TAI: "Current password",
  ACC_MAT_KHAU_INT_BANK: "Password",
  ACC_CAPCHA_INT_BANK: "Protection Code",
  ACC_MAT_KHAU_MOI: "New password",
  ACC_MAT_KHAU_XAC_MINH_KHONG_DUNG: "New password does not match",
  ACC_CAPCHA_XAC_MINH_KHONG_DUNG: "Please input protection code correct",
  ACC_CAPCHA_XAC_MINH_CHUA_NHAP: "Please input protection code",
  ACC_MO_ONLINE: "Online",
  ACC_MO_TA: "Description",
  ACC_MO_TAI_QUAY: "At the counter",
  ACC_NGAY_DEN_HAN: "Due date",
  ACC_NGAY_HET_HAN: "Release date",
  ACC_NGAY_HIEU_LUC: "Lease date",
  ACC_NGAY_MO_TAI_KHOAN: "Open date",
  ACC_NGAY_MO_SO: "Deposit open date",
  ACC_NGAY_NHAN_LAI_KE_TIEP: "Next interest date",
  ACC_NHAP_LAI_MAT_KHAU: "Enter password again",
  ACC_NHAP_MAT_KHAU: "Enter password",
  ACC_ONLINE: "Online",
  ACC_QUAN_LY_TAI_KHOAN: "Manage account",
  ACC_QUAN_LY: "Manage",
  ACC_QUAY_LAI: "Back",
  ACC_QUEN_MAT_KHAU: "Forgot password",
  ACC_QUY_KHACH_MUON_HUY_GIAO_DICH: "Do want to cancel this transaction?",
  ACC_SAN_PHAM: "Products",
  ACC_SAO_KE_GIAO_DICH: "Statement transaction",
  ACC_SAO_KE: "Statement",
  ACC_SO_BUT_TOAN: "Number of entries",
  ACC_SO_DU: "Balance",
  ACC_SO_DU_HIEN_TAI: "Current balance",
  ACC_SO_DU_KHA_DUNG: "Available balance",
  ACC_SO_DU_KHA_DUNG_NOT_ENOUGH: "Available balance is not enough to make a transaction.",
  ACC_SO_DU_SO: "Deposit balance",
  ACC_SO_DU_GOC: "Primary Balance",
  ACC_SO_HOP_DONG: "Contract number",
  ACC_SO_TAI_KHOAN: "Account number",
  ACC_SO_TIEN: "Amount",
  ACC_TAI_KHOAN_THANH_TOAN: "Payment account ",
  ACC_TAI_KHOAN_TIEN_GUI_TRA_LAI_SAU: "Deposit accounts pay interest later",
  ACC_TAI_KHOAN_TIEN_GUI_TRA_LAI_TRUOC: "Deposit accounts pay interest in advance",
  ACC_TAI_KHOAN_TIEN_VAY: "Loan account",
  ACC_TAI_KHOAN_TIET_KIEM: "Saving account",
  ACC_TAI_QUAY: "At the counter",
  ACC_TAT_CA_TAI_KHOAN: "All account",
  ACC_TEN_DANG_NHAP: "Username",
  ACC_TEN_SAN_PHAM: "Product name",
  ACC_TEN_TAI_KHOAN: "Account name",
  ACC_THOI_GIAN: "Time",
  ACC_THONG_BAO_DOI_MAT_KHAU_THANH_CONG: "Change password successfully. Please login again.",
  ACC_THONG_BAO_NGAY_BAT_DAU_KHONG_QUA_90_NGAY: "Date and time must be within 90 days",
  ACC_THONG_BAO_NGAY_BAT_DAU_KHONG_QUA_SO_NGAY: "Date and time must be within {day} days",
  ACC_THONG_BAO_NGAY_BAT_DAU_TRUOC_NGAY_KET_THUC: "End-date must be after begin-date",
  ACC_VUI_LONG_CHON_DAY_BAT_DAU: "Please select a start date",
  ACC_VUI_LONG_CHON_DAY_KET_THUC: "Please select an end date",
  ACC_THONG_BAO_VUI_LONG_CHON_TAI_KHOAN: "Please select account",
  ACC_TIEP_TUC: "Continue",
  ACC_TIM_KIEM_TAI_KHOAN: "Search by account",
  ACC_TONG_SO_GIAO_DICH: "Total {count} transaction",
  ACC_TRANG_THAI: "Status",
  ACC_TRA_SOAT_GIAO_DICH: "Dispute transaction",
  ACC_WEBSITE: "Website",
  ACC_DANG_KI_TRUC_TUYEN: "Register Online",
  ACC_HOAC: "Or",
  ACC_PVCB_CONNECT_LA_GI: "What is PVcomBank Connect?",
  ACC_DANH_SACH_TAI_KHOAN: "List of accounts",
  ACC_LOAI_TAI_KHOAN: "Account Type",
  ACC_SO_TIEN_PHONG_TOA: "Banned Amount",
  ACC_GIAO_DICH_GAN_NHAT: "Lasted by payment",
  ACC_HAN_MUC_THAU_CHI: "Overdraft Limit",
  ACC_XEM_SAO_KE: "Watch Statement",
  ACC_XUAT_SO_PHU: "Export Statements",
  ACC_XUAT_EXCEL: "Export file excel",
  ACC_DIEN_THOAI_DI_DONG: "Mobile phone",
  ACC_DIEN_THOAI: "Home phone",
  ACC_GIAY_TO_TUY_THAN: "Paper of issues",
  ACC_SO_GIAY_TO: "Number of personal papers",
  ACC_NGAY_CAP: "Date of create",
  ACC_DIA_CHI_NOI_CAP: "Address of issues",
  ACC_KIEU_XAC_THUC: "Authorization type",
  ACC_THAY_ANH_DAI_DIEN: "Change avatar",
  ACC_XAC_THUC_SMS: "SMS",
  ACC_XAC_THUC_SMART_OTP: "Smart OTP",
  ACC_LAI_IN_INSTANT: "Interest rate of the day",
  ACC_SDT_XAC_THUC: "Authentication phone number",
  ACC_SO_LAI_NHAN_DUOC: "The amount of interest received",
  ACC_CHI_NHANH: "Branch",
  ACC_CHI_NHANH_QL_SO: "Deposit management branch",
  ACC_NGAY_TRA_LAI_KE_TIEP: "Next interest payment date",
  ACC_LICH_SU_GIAO_DICH: "Transaction history",
  ACC_NGAY_GIAO_DICH: "Transaction date",
  ACC_SO_THAM_CHIEU: "Reference Number",
  ACC_SO_TIEN_GHI_NO: "Debit amount",
  ACC_SO_TIEN_GHI_CO: "Amount available",
  ACC_NOI_DATE: "Content",
  ACC_TAI_VE: "Download",
  ACC_MIN: "Minimum",
  ACC_MAX: "Maximum",
  ACC_LOAI_GIAO_DICH: "Transaction type",
  ACC_THANH_CONG: "Success",
  ACC_KHONG_THANH_CONG: "Failed",
  ACC_PAGE_THAI_GD: "Transaction Status",
  ACC_TIM_NANG_CAO: "Advanced Search",
  ACC_TIM_CO_BAN: "Basic Search",
  ACC_DAY_LAP_LENH: "Order date",
  ACC_PHI_GD: "Transaction Fee",
  ACC_TK_NHAN: "Receivable account",
  ACC_TEN_NGUOI_NHAN: "Recipient's name",
  ACC_TEN_NGUOI_CHUYEN: "Sent name",
  ACC_CHI_TIET_GIAO_DICH: "Transaction details",
  ACC_NGAN_HANG_NHAN: "Receiving Bank",
  ACC_NGAN_HANG_CHUYEN: "Bank transfer",
  ACC_CHUA_CO_GD_PHAT_SINH: "No transaction yet",

  ATM_BUTON_THONG_BAO_KHONG: "No, thank you",
  ATM_CHI_NHANH_ATM: "ATM",
  ATM_CHI_NHANH_CHI_NHANH: "Branch",
  ATM_CHI_NHANH_KHONG_TIM_THAY_TIM_KIEM: "No result",
  ATM_CHI_NHANH_TAT_CA: "All",
  ATM_NOI_DUNG_MO_LOCATION_SETTING: "Please access Settings - Application on device to grant location access for the application.",
  ATM_THONG_BAO_BAT_LOCATION_THIET_BI: "PVcomBank needs your position. Please turn on the device's location service.",

  AUTO_BILLING_DANG_KY_THANH_TOAN_HOA_DON_TU_DONG: "Register auto billing",
  AUTO_BILLING_DANG_KY_THANH_TOAN_TU_DONG_THANH_CONG: "Successful automatic bill payment service {service}",
  AUTO_BILLING_DANG_KY_THEM: "Add register",
  AUTO_BILLING_DICH_VU: "Service",
  AUTO_BILLING_DICH_VU_CHUA_HO_TRO_DANG_KY: "The service have not supported automatic bill payment.",
  AUTO_BILLING_GHI_CHU: "Note",
  AUTO_BILLING_GOI_DICH_VU: "Service package",
  AUTO_BILLING_KHONG_CO_GIAO_DICH_NAO: "No transaction",
  AUTO_BILLING_LICH_SU_GIAO_DICH: "Transaction history",
  AUTO_BILLING_LI_DO: "Reason",
  AUTO_BILLING_MA_HOA_DON: "Invoice No",
  AUTO_BILLING_MA_HOA_DON_DA_DANG_KY_THANH_TOAN_TU_DONG: "Invoice No or Customer No registered for automatic payment.",
  AUTO_BILLING_MA_HOA_DON_KHACH_HANG: "Invoice No/Customer No/Phone No",
  AUTO_BILLING_MO_TA: "Description",
  AUTO_BILLING_NGAY_DANG_KY: "Registration date",
  AUTO_BILLING_NGAY_THANH_TOAN: "Payment date",
  AUTO_BILLING_CHON_NGAY_THANH_TOAN: "Select payment date",
  AUTO_BILLING_NGAY_THANH_TOAN_HOA_DON: "{ngay_thanh_toan} month of every month",
  AUTO_BILLING_NHA_CUNG_CAP: "Provider",
  AUTO_BILLING_NOTE_CHUYEN_NHANH_THU_HUONG_GIAO_DICH: "To faster trading and no need to remember the information",
  AUTO_BILLING_PHUONG_THUC_THANH_TOAN: "Payment method",
  AUTO_BILLING_CHON_PHUONG_THUC_THANH_TOAN: "Select payment method",
  AUTO_BILLING_QUY_KHACH_MUON_HUY_GIAO_DICH: "Do you want to cancel this transaction?",
  AUTO_BILLING_SO_TIEN: "Amount",
  AUTO_BILLING_TAI_KHOAN_NGUON: "Source account",
  AUTO_BILLING_TAI_KHOAN_THANH_TOAN: "Payment account",
  AUTO_BILLING_TAI_KHOAN_TRICH_NO: "Debit account",
  AUTO_BILLING_THANH_TOAN_CO_DINH: "Fixed monthly date",
  AUTO_BILLING_THANH_TOAN_HOA_DON_TU_DONG: "Auto billing",
  AUTO_BILLING_THANH_TOAN_NGAY_PHAT_SINH_NO: "As soon as a debt arises",
  AUTO_BILLING_THOI_GIAN_GIAO_DICH: "Transaction time",
  AUTO_BILLING_THONG_BAO_NGAY_BAT_DAU_KHONG_QUA_90_NGAY: "Date and time must be within 90 days",
  AUTO_BILLING_THONG_BAO_NGAY_BAT_DAU_TRUOC_NGAY_KET_THUC: "End-date must be after begin-date",
  AUTO_BILLING_THONG_BAO_TRANG_THAI_TAI_KHOAN: "Payment account is inactive. Please contact the nearest branch to support .",
  AUTO_BILLING_THONG_TIN_DANG_KY: "Registration information",
  AUTO_BILLING_TRUY_VAN: "Inquiry",
  AUTO_BILLING_VUI_LONG_CHON_NGAY_THANH_TOAN: "Please select payment date",
  AUTO_BILLING_VUI_LONG_CHON_MA_HOA_DON: "Please select Invoice No/Customer No/Phone No",
  AUTO_BILLING_VUI_LONG_NHAP_MA_HOA_DON: "Please enter invoice no. or customer no.",
  BILLING_VUI_LONG_CHON_DICH_VU: "Please select service",
  BILLING_VUI_LONG_CHON_NHA_CUNG_CAP: "Please choose a supplier",
  BILLING_VUI_LONG_CHON_GOI_DICH_VU: "Please choose a service package",
  AUTO_BILLING_VUI_LONG_NHAP_NHA_CUNG_CAP: "Please enter provider",
  AUTO_SERVICE_XOA_DICH_VU: "Delete service invoice",

  AUTO_TOPUP_DANH_SACH_DANG_KY_NAP_TIEN_TU_DONG: "List of automatic recharge registrations",
  AUTO_TOPUP_CHON_NGAY_DAT: "Select payment date",
  AUTO_TOPUP_CHON_NGAY_NAP: "Select topup date",
  AUTO_TOPUP_CHON_NHA_MANG: "Choose network",
  AUTO_TOPUP_DANG_KY_NAP_TIEN_TU_DONG: "Auto topup register",
  AUTO_TOPUP_DANG_KY_NAP_TIEN_TU_DONG_THANH_CONG: "Automatic topup registration successful",
  AUTO_TOPUP_DANG_KY_THEM: "Register more",
  AUTO_TOPUP_HO_VA_TEN: "Full name",
  AUTO_TOPUP_KHONG_CO_GIAO_DICH_NAO: "No transaction",
  AUTO_TOPUP_KHONG_CO_NHA_MANG: "No Network Service Provider",
  AUTO_TOPUP_LAN_KHUYEN_MAI_DAU_TIEN: "The first time promotion of the month",
  AUTO_TOPUP_LICH_SU_GIAO_DICH: "Transaction history",
  AUTO_TOPUP_MENH_GIA: "Denomination",
  AUTO_TOPUP_NAP_TIEN_TU_DONG: "Auto topup",
  AUTO_TOPUP_NGAY_DAT: "Payment date",
  AUTO_TOPUP_NGAY_NAP: "Topup date",
  AUTO_TOPUP_NGAY_THANH_TOAN: "Payment date",
  AUTO_TOPUP_NHA_MANG: "Network Service Provider",
  AUTO_TOPUP_NOTE_CHUYEN_NHANH_THU_HUONG_GIAO_DICH: "To faster trading and no need to remember the information?",
  AUTO_TOPUP_QUY_KHACH_MUON_HUY_GIAO_DICH: "Do you want to cancel this transaction?",
  AUTO_TOPUP_SO_DIEN_THOAI: "Phone number",
  AUTO_TOPUP_SO_DIEN_THOAI_DA_DANG_KY_NAP_TIEN_TU_DONG: "This phone number is registed auto topup servies.",
  AUTO_TOPUP_SO_DIEN_THOAI_KHONG_HOP_LE: "The phone number is not correct. Please check again.",
  AUTO_TOPUP_SO_TIEN: "Amount",
  AUTO_TOPUP_TAI_KHOAN_NGUON: "Source account",
  AUTO_TOPUP_TAI_KHOAN_THANH_TOAN: "Payment account ",
  AUTO_TOPUP_TAI_KHOAN_TRICH_NO: "Debit acount",
  AUTO_TOPUP_THONG_BAO_NGAY_BAT_DAU_KHONG_QUA_90_NGAY: "Date and time must be within 90 days",
  AUTO_TOPUP_THONG_BAO_NGAY_BAT_DAU_TRUOC_NGAY_KET_THUC: "End-date must be after begin-date",
  AUTO_TOPUP_THONG_BAO_TRANG_THAI_TAI_KHOAN: "Payment account is inactive.  Please contact the nearest branch to support .",
  AUTO_TOPUP_THONG_TIN_DANG_KY: "Registration information",
  AUTO_TOPUP_THONG_TIN_NAP_TIEN: "Topup info",
  AUTO_TOPUP_TIM_NHA_MANG: "Find network",
  AUTO_TOPUP_VUI_LONG_CHON_NHA_MANG: "Please select network operator",
  AUTO_TOPUP_VUI_LONG_CHON_SO_DIEN_THOAI: "Please select phone number",
  AUTO_TOPUP_VUI_LONG_CHON_TAI_KHOAN_NGUON: "Please select payment account",
  AUTO_TOPUP_VUI_LONG_NHAP_HO_VA_TEN: "Please enter full name",
  AUTO_TOPUP_VUI_LONG_NHAP_SO_DIEN_THOAI: "Please enter phone number",
  AUTO_TOPUP_NGAY_NAP_HANG_THANG: "{ngay} month of every month",

  BENE_CARD_NAP_TIEN_VAO_THE_TRA_TRUOC: "Topup to prepaid card ",
  BENE_CARD_THANH_TOAN_THE_TIN_DUNG: "Credit card payment",
  BENE_CASH_BY_CODE_TITLE: "Cash by code",
  BENE_CHI_TIET_THU_HUONG: "Beneficiary details",
  BENE_CHON_LOAI_GIAO_DICH: "Seclect transaction type",
  BENE_CHUA_CO_THONG_TIN_THU_HUONG: "No beneficiary information",
  BENE_CHON_TK_THU_HUONG: "Select beneficiary account",
  BENE_CHON_HOA_DON_DANH_SACH: "Select billing",
  BENE_CHON_SDT_TK_DV: "Select Phone number/ Account",
  BENE_CHON_SDT: "Select Phone number",
  BENE_CHUC_NANG_SAP_RA_MAT: "Funtion is coming soon.",
  BENE_CHUYEN_DEN_PROFILE_KHAC: "Move to other profile",
  BENE_CHUYEN_TIEN: "Transfer",
  BENE_CHUYEN_TIEN_CHUNG_KHOAN: "Transfer to PSI account",
  BENE_CHUYEN_TIEN_NGOAI_PVCOMBANK: "Interbank",
  BENE_CHUYEN_TIEN_NHANH_247: "Real time money transfer 24/7",
  BENE_CHUYEN_TIEN_TRONG_PVCOMBANK: "Transfer on intrabank",
  BENE_DANH_SACH_THU_HUONG: "Beneficiary list",
  BENE_DANH_SACH_THU_HUONG_CHUYEN_DEN: "Beneficiary list",
  BENE_DIA_CHI: "Address",
  BENE_DICH_VU: "Services",
  BENE_DICH_VU_CHUNG_KHOAN: "PSI service",
  BENE_HET_DU_LIEU: "Out of data",
  BENE_HO_TEN: "Full name",
  BENE_HUY: "Cancel",
  BENE_KHONG_CO_THONG_TIN_YEU_CAU: "No result",
  BENE_KHONG_PHAI_KI_TU_TRONG_BANG_CHU_CAI: "Other",
  BENE_LOAI_GIAO_DICH: "Transaction type",
  BENE_LUU: "Save",
  BENE_MA_HOA_DON: "Invoice No",
  BENE_NAP_TIEN: "Topup",
  BENE_NGAN_HANG: "Bank",
  BENE_NGOAI_NGAN_HANG: "Interbank",
  BENE_NHA_CUNG_CAP: "Provider",
  BENE_QUY_KHACH_CHUA_TAO_LOAI_THU_HUONG_NAO: "You have not created any beneficiary. Please click create new below",
  BENE_QUY_KHACH_CO_MUON_XOA_PROFILE_THU_HUONG: "Do you want to delete this profile?",
  BENE_QUY_KHACH_MUON_HUY_TEMPLATE_THU_HUONG: "Do you want to delete this beneficiary information?",
  BENE_QUY_KHACH_MUON_HUY_THU_HUONG: "Beneficiary information has not been saved. Do want to cancel this template?",
  BENE_SO_DIEN_THOAI: "Phone number",
  BENE_SO_DIEN_THOAI_KHONG_HOP_LE: "Invalid phone number. Please try again.",
  BENE_SO_DIEN_THOAI_SO_TAI_KHOAN: "Phone number/Account number",
  BENE_SO_DIEN_THOAI_SO_TAI_KHOAN_KHONG_DUOC_DE_TRONG: "Please enter phone number/Account number",
  BENE_SO_DIEN_THOAI_TAI_KHOAN_DICH_VU: "Phone number/Service account",
  BENE_MA_HD_KH_SDT: "Invoice No/Customer No/Phone No",
  BENE_SO_DIEN_THOAI_TAI_KHOAN_KHONG_TON_TAI: "Phone number/Account number does not exits",
  BENE_SO_TAI_KHOAN: "Account number",
  BENE_SO_TAI_KHOAN_SO_THE: "Account number/ Card number",
  BENE_SO_TAI_KHOAN_CHUNG_KHOAN: "PSI account number",
  BENE_SO_THE: "Card number",
  BENE_SO_THE_THU_HUONG_KHONG_DUOC_DE_TRONG: "Please enter card number",
  BENE_SO_TIEN: "Amount",
  BENE_SUA: "Edit",
  BENE_SUA_GIAO_DICH_THU_HUONG: "Edit beneficiary information",
  BENE_TAI_KHOAN_THU_HUONG_KHONG_TON_TAI: "Receive account does not exist.",
  BENE_TAI_KHOAN_THU_HUONG: "Beneficiary accounts",
  BENE_TAI_KHOAN_CUA_TOI: "My accounts",
  BENE_TEN_CHU_TAI_KHOAN: "Account holder name",
  BENE_THANH_TOAN: "Payment",
  BENE_THANH_TOAN_CUOC_VIEN_THONG: "Payment of telecommunications charges",
  BENE_THANH_TOAN_HOA_DON: "Payment billing",
  BENE_THEM_GIAO_DICH_THU_HUONG: "Beneficiary information",
  BENE_THEM_LOAI_HINH_THU_HUONG: "Add beneficiary type",
  BENE_THONG_BAO_KIEM_TRA_SO_THE: "Invalid card number. Please try again.",
  BENE_THONG_TIN_THU_HUONG: "Beneficiary information",
  BENE_TIM_KIEM: "Search",
  BENE_TRONG_PVCOMBANK: "Intrabank",
  BENE_TUY_CHON: "Options",
  BENE_UA_THICH: "Favourite",
  BENE_VAN_TIN_TAI_KHOAN: "Inquiry account",
  BENE_VUI_LONG_CHON_CHI_NHANH: "Please select a branch",
  BENE_VUI_LONG_CHON_KHU_VUC: "Please select an area",
  BENE_VUI_LONG_CHON_NGAN_HANG: "Please select a bank",
  BENE_VUI_LONG_NHAP_CHI_NHANH_KHAC: "Please select other branch",
  BENE_VUI_LONG_NHAP_HO_VA_TEN: "Please enter name",
  BENE_VUI_LONG_NHAP_MA_HOA_DON_THU_HUONG: "Please enter Invoice no. or Customer no.",
  BENE_VUI_LONG_NHAP_SO_DIEN_THOAI: "Please enter phone number",
  BENE_VUI_LONG_NHAP_SO_DIEN_THOAI_SO_TAI_KHOAN: "Please enter phone number/account",
  BENE_VUI_LONG_NHAP_SO_TAI_KHOAN: "Please enter account number",
  BENE_VUI_LONG_NHAP_SO_TAI_KHOAN_CHUNG_KHOAN: "Please enter PSI account number",
  BENE_VUI_LONG_NHAP_SO_TAI_KHOAN_KHONG_CO_DAU: "Please do not enter account number accented Vietnamese and containing special characters",
  BENE_VUI_LONG_NHAP_SO_THE: "Please enter card number",
  BENE_VUI_LONG_NHAP_SO_THE_KHONG_CO_DAU: "Please do not enter ATM card accented Vietnamese and containing special characters",
  BENE_VUI_LONG_NHAP_TEN_TAI_KHOAN: "Please enter account name",
  BENE_VUI_LONG_NHAP_TEN_TAI_KHOAN_CHUNG_KHOAN: "Please enter PSI account name",
  BENE_VUI_LONG_NHAP_TEN_TAI_KHOAN_KHONG_CO_DAU:
    "Please do not enter account name accented Vietnamese and containing special characters except dash and dot",
  BENE_VUI_LONG_NHAP_TEN_GOI_NHO: "Please enter a reminder name",
  BENE_XOA: "Delete",
  BENE_LUU_THU_HUONG: "Beneficiary save",
  BENE_TEN_GOI_NHO: "Remind name",

  BIEU_DO_MAX: "Maximum (VND)",
  BIEU_DO_MIN: "Minimum (VND)",

  BILLING_CHUA_DANG_KY_THANH_TOAN_GIAO_DICH: "You do not have any invoice to register for automatic payment.",
  BILLING_CHUC_NANG_THANH_TOAN_HOA_DON: "Payment billing",
  BILLING_DICH_VU: "Service",
  BILLING_DIEN_THOAI_CO_DINH: "Home phone",
  BILLING_DIEN_THOAI_CO_DINH_GPHONE_VNPT: "Home phone, Gphone- VNPT",
  BILLING_DIEN_THOAI_HOME_PHONE: "Homephone",
  BILLING_DV_CONG: "Public service",
  BILLING_DV_TRUYEN_HINH: "TV service",
  BILLING_DV_TRUYEN_HINH_VNPT: "TV service - VNPT",
  BILLING_GOI_DICH_VU: "Service package",
  BILLING_HOA_DON_ADSL: "ADSL",
  BILLING_HOA_DON_ADSL_VNPT: " ADSL - VNPT",
  BILLING_HOA_DON_DIEN_THOAI_TRA_SAU: "Postpaid phone",
  BILLING_HOA_DON_INTERNET_TV: "Internet TV",
  BILLING_HOA_DON_LEASED_LINE: "Leased-line",
  BILLING_KHONG_CO_DU_LIEU: "No data",
  BILLING_MA_HOA_DON: "Invoice No",
  BILLING_MA_HOA_DON_KHACH_HANG: "Customer no/ Invoice no/ Phone No",
  BILLING_MA_HOA_DON_KHACH_HANG_KHONG_DUNG: "Customer no/ Invoice no/ Phone No invalid",
  BILLING_MA_KHACH_HANG: "Customer no",
  BILLING_NAP_TIEN_THANH_CONG: "Payment {so_tien} succsessful for {hoa_don} bill {ma}",
  BILLING_NGAY_THANH_TOAN: "Payment date",
  BILLING_NHA_CUNG_CAP: "Provider",
  BILLING_NOTE_GIAO_DICH_NHANH_THU_HUONG: "To faster trading and no need to remember the information?",
  BILLING_QUY_KHACH_MUON_HUY_GIAO_DICH: "Do you want to cancel this transaction?",
  BILLING_SO_TIEN: "Amount",
  BILLING_SO_TIEN_THANH_TOAN: "Payment amount",
  BILLING_TAI_KHOAN_NGUON: "Source account",
  BILLING_THANH_TOAN_HOA_DON: "Payment billing",
  BILLING_THONG_BAO_TRANG_THAI_TAI_KHOAN_CHUYEN: "The transfer account is inactive. Please contact the nearest branch for support.",
  BILLING_THONG_TIN_HOA_DON: "Bill information",
  BILLING_TIEN_DIEN: "Electricty",
  BILLING_TIEN_NUOC: "Water",
  BILLING_TIM_GOI_DICH_VU: "Search by service package name",
  BILLING_TIM_NHA_CUNG_CAP: "Search by provider name",
  BILLING_VE_MAY_BAY: "Airline ticket",
  BILLING_VE_MAY_BAY_NEW: "Air Ticket bill payment",
  BILLING_VUI_LONG_NHAP_MA_HOA_DON: "Please enter bill code or customer code to pay.",
  BILLING_THANH_TOAN_TOAN_BO_CUOC: "Pay the full charge",

  CARD_BAN_CHUA_DANG_KI_LOAI_THE_GHI_NO_NAY: "You do not have any debit card",
  CARD_BAN_CHUA_DANG_KI_LOAI_THE_NAY: "You do not have any card",
  CARD_BAN_CHUA_DANG_KI_LOAI_THE_TIN_DUNG_NAY: "You do not have any credit card",
  CARD_BAN_CHUA_DANG_KI_LOAI_THE_TRA_TRUOC_NAY: "You do not have any prepaid card",
  CARD_BY_CODE_QUY_KHACH_MUON_HUY_GIAO_DICH: "Do you want to cancel this transaction?",
  CARD_CHECK_NOTE_DIEU_KHOAN: "I have read, understood and agreed all the Terms & Conditions for non-physical prepaid card of PVcomBank",
  CARD_CHI_TIET_THE: "Card detail",
  CARD_CHON_HINH_THUC_THANH_TOAN: "Select payment method",
  CARD_CHON_LOAI_PHAT_HANH_THE: "Card issuing type",
  CARD_CHON_NGUON_KHAC: "Select other source",
  CARD_CHU_THE: "Card holder",
  CARD_DANG_KY: "Register",
  CARD_DANG_KY_PHAT_HANH_THE_PV: "REGISTER NOW",
  CARD_DANG_KY_PHAT_HANH_THE_VAT_LY: "Register to issue physical cards",
  CARD_DANH_SACH_THE: "Card list",
  CARD_DANH_SACH_THE_TIN_DUNG: "Credit card list",
  CARD_DAT_LAM_THE_THANH_TOAN_MAC_DINH: "Set as default payment card",
  CARD_DA_CO_LOI_XAY_RA: "An error was occurred",
  CARD_DIA_CHI: "Address",
  CARD_DICH_VU: "Service",
  CARD_DICH_VU_THE: "Card service",
  CARD_DIEU_KHOAN_DIEU_KIEN_SU_DUNG: "Term & Policies",
  CARD_DIEU_KHOAN_PHAT_HANH_THE_VAT_LY:
    "I warrant that all information I provide above is absolutely correct. I confirm that I have read and agree to the Terms, conditions of reissuing & using PVcomBank card. I agree to allow PVcomBank to use my information to introduce PVcomBank's products, services and promotions from now on.",
  CARD_DOWNLOAD_FILE_SAO_KE: "Download detailed statement",
  CARD_DU_NO: "Debit balance",
  CARD_DU_NO_CAN_THANH_TOAN: "Outstanding balance to be paid",
  CARD_DU_NO_CON_LAI: "Balance outstanding",
  CARD_EMAIL: "Email",
  CARD_GHI_CHU_KHONG_NAP_TIEN_NGAY: "If not topup immediately after card issuance. Please do not enter amount.",
  CARD_GIAO_DICH_KHAC: "Other transactions",
  CARD_GIOI_THIEU_CHUC_NANG_PHAT_HANH_THE_VAT_LY: "Please provide information, PVcomBank will contact you as soon as possible",
  CARD_HAN_MUC_GIAO_DICH_ATM: "ATM withdraw limit",
  CARD_HAN_MUC_GIAO_DICH_ATM_ASC: "Maximum daily ATM withdrawal limit is {}",
  CARD_HAN_MUC_GIAO_DICH_ATM_DESC: "Maximum daily ATM withdraw limit is {}",
  CARD_HAN_MUC_GIAO_DICH_CHUYEN_TIEN: "Transfer limit/ day",
  CARD_HAN_MUC_GIAO_DICH_NGAY: "Daily transaction limit",
  CARD_HAN_MUC_GIAO_DICH_RUT_ATM: "ATM withdraw limit/ day",
  CARD_HAN_MUC_GIAO_DICH_THUONG_MAI_ASC: "Maximum daily e-commerce transaction limit is {}",
  CARD_HAN_MUC_GIAO_DICH_THUONG_MAI_DESC: "Maximum daily e-commerce transaction limit is {}",
  CARD_HAN_MUC_GIAO_DICH_THUONG_MAI_DIEN_TU: "E-commerce transaction limit",
  CARD_HAN_MUC_GIAO_DICH_TRUC_TUYEN: "Online transaction limit/ day",
  CARD_HAN_MUC_THE: "Card limit",
  CARD_HO_VA_TEN: "Full name",
  CARD_KHOA: "Lock",
  CARD_KHOA_GIAO_DICH_TRUC_TUYEN: "Lock online transaction",
  CARD_KHOA_MO_GIAO_DICH_TRUC_TUYEN: "Lock/Unlock online transaction",
  CARD_KHOA_MO_GIAO_DICH_TRUC_TUYEN_FUN: "Lock / Unlock online transactions",
  CARD_KHOA_MO_THE: "Lock/Unlock card",
  CARD_KHOA_MO_THE_FUN: "Activate / Lock / Unlock the card",
  CARD_KHOA_THE: "Lock card ",
  CARD_KICH_HOAT: "Activated",
  CARD_KICH_HOAT_NHAP_4_SO_CUOI: "Please enter the last 4 digits on the card",
  CARD_KICH_HOAT_GIAO_DICH_TRUC_TUYEN: "Active online transaction",
  CARD_KICH_HOAT_THE: "Activate card",
  CARD_LICH_SU_GIAO_DICH: "Transaction history",
  CARD_LOAI_THE: "Card type",
  CARD_CHON_LOAI_THE: "Choose card type",
  CARD_LOI_THAM_SO: "Parameter error",
  CARD_MAX: "MAX",
  CARD_MA_GIAO_DICH: "Transaction code",
  CARD_MIN: "MIN",
  CARD_MO: "active",
  CARD_MO_TA: "Description",
  CARD_MO_THE: "Unlock  card",
  CARD_NAP_TIEN_THE_TRA_TRUOC: "Topup prepaid card",
  CARD_NAP_TIEN_VAO_THE: "Topup card ",
  CARD_NAP_TIEN_VAO_THE_TRA_TRUOC: "Recharge prepaid card",
  CARD_NGAY_DEN_HAN_THANH_TOAN: "Due date",
  CARD_NGAY_SAO_KE: "Statement date",
  CARD_NGUON_THANH_TOAN: "Payment source",
  CARD_NHAP_SO_THE_KHONG_HOP_LE: "Invalid card number. Please try again.",
  CARD_NOTE_CHUYEN_NHANH_THU_HUONG: "To transfer money faster and do not need to remember the information?",
  CARD_PHAT_HANH_THE: "Issue the card",
  CARD_PHAT_HANH_THEM: "Add reissue",
  CARD_PHAT_HANH_THE_TRA_TRUOC: "Issue prepaid card",
  CARD_PHAT_HANH_THE_VAT_LY: "Issue physical card",
  CARD_PHI_GIAO_DICH: "Fee",
  CARD_QUY_KHACH_MUON_HUY_GIAO_DICH: "Do you want to cancel this transaction?",
  CARD_SAO_KE_THE: "Card statement",
  CARD_SAO_KE_THE_TIN_DUNG: "Credit card statement",
  CARD_SO_CVC: "CVC number",
  CARD_SO_DIEN_THOAI: "Phone number",
  CARD_SO_DIEN_THOAI_KHONG_HOP_LE: "Invalid phone number. Please try again.",
  CARD_SO_DU_THE: "Card balance",
  CARD_SO_DU_KHA_DUNG: "Available balance",
  CARD_SO_TAI_KHOAN: "Account number",
  CARD_SO_THE: "Card number",
  CARD_SO_THE_KHAC: "Other card number",
  CARD_SO_THE_NAP: "Card number",
  CARD_SO_TIEN: "Amount",
  CARD_SO_TIEN_NAP: "Toup amount",
  CARD_SO_TIEN_NAP_TOI_DA_THE_VO_DANH: "Maximum topup amount is {so_tien}",
  CARD_SO_TIEN_NAP_TOI_THIEU: "Minimum toup amount is {so_tien}",
  CARD_SO_TIEN_THANH_TOAN: "Payment amount",
  CARD_SO_TIEN_THANH_TOAN_TOI_THIEU: "Minimum payment amount",
  CARD_SO_TIEN_THANH_TOAN_TOI_THIEU_KHONG_DU: "The current minimum payment amount is not enough to make transaction",
  CARD_SO_TIEN_THANH_TOAN_KHONG_HOP_LE: "Invalid payment amount",
  CARD_SO_TIEN_TOI_DA_NGAY: "Maximum amount/day",
  CARD_SO_TIEN_TONG_DU_NO_KHONG_DU: "Current total balance is not enough to make a transaction",
  CARD_TAB_KICH_HOAT_THE: "Activate card",
  CARD_TAB_LICH_SU_GD: "Transaction{new_line}history",
  CARD_TAB_SAO_KE: "Statement",
  CARD_TAB_THANH_TOAN_DU_NO: "Payment of{new_line}outstanding debit'",
  CARD_TAB_THONG_TIN_THE: "Card info",
  CARD_TAI_KHOAN_CHUYEN: "Transfer account",
  CARD_TAI_KHOAN_NGUON: "Source account",
  CARD_TAI_KHOAN_THANH_TOAN: "Payment account",
  CARD_TAI_KHOAN_THE: "Card account",
  CARD_TAT_CA_CARD_DANH_SACH_THE: "All list card",
  CARD_TEN_CHU_THE: "Account holder name",
  CARD_TEXT_NGAY_SAO_KE: "[date] monthly",
  CARD_THANG_SAO_KE: "Statement month",
  CARD_THANH_TOAN_CHO_THE: "Pay for card",
  CARD_THANH_TOAN_DU_NO: "Payment of debit",
  CARD_THANH_TOAN_THE: "Card payment",
  CARD_THANH_TOAN_THE_TIN_DUNG: "Credit card payment",
  CARD_THANH_TOAN_THE_TIN_DUNG_CHU_THE: "Account name",
  CARD_THANH_TOAN_THE_TIN_DUNG_DICH_VU: "Services",
  CARD_THANH_TOAN_THE_TIN_DUNG_HINH_THUC_THANH_TOAN: "Payment method",
  CARD_THANH_TOAN_THE_TIN_DUNG_NOI_DUNG: "Content",
  CARD_THANH_TOAN_THE_TIN_DUNG_SO_THE: "Card number",
  CARD_THANH_TOAN_THE_TIN_DUNG_SO_TIEN_THANH_TOAN: "Amount",
  CARD_THANH_TOAN_THE_TIN_DUNG_THANH_TOAN_CA_NHAN: "Personal payment",
  CARD_THANH_TOAN_THE_TIN_DUNG_THANH_TOAN_DU_NO: "Payment of outstanding debit",
  CARD_THANH_TOAN_THE_TIN_DUNG_THANH_TOAN_HO: "Payment to others",
  CARD_THANH_TOAN_THE_TIN_DUNG_THANH_TOAN_TOAN_BO_DU_NO: "Payment of all outstanding statement period",
  CARD_THANH_TOAN_THE_TIN_DUNG_THANH_TOAN_TOI_THIEU: "Minimum payment",
  CARD_THANH_TOAN_THE_TIN_DUNG_THANH_TOAN_TUY_CHON: "Payment option",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_HUY_GIAO_DICH: "Do you want to cancel this transaction?",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_NOI_DUNG_THANH_TOAN_KHONG_HOP_LE:
    "Please do not enter Content is Vietnamese with special signs and characters except dashes and dots",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_SO_TIEN_TOI_THIEU: "Minimum transfer amount is 10,000 VND",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_VUI_LONG_NHAP_DU_THONG_TIN: "Please enter full information",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_VUI_LONG_NHAP_NOI_DUNG_THANH_TOAN: "Please enter transaction content",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_VUI_LONG_NHAP_SO_THE: "Please enter card number",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_VUI_LONG_NHAP_SO_TIEN_THANH_TOAN: "Please enter transaction amount",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_VUI_LONG_NHAP_TEN_CHU_THE: "Please enter card holder",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_BAO_LOI_SO_TIEN_THANH_TOAN_TOI_THIEU:
    "Transaction amount is greater than or equal to the minimum payment amount",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_THE_SAI_SO_THE: "Invalid number card. Please try again.",
  CARD_THANH_TOAN_THE_TIN_DUNG_THONG_TIN_THANH_TOAN: "Payment info",
  CARD_THANH_TOAN_THE_TIN_DUNG_TONG_DU_NO: "Total outstanding balance of statement period",
  CARD_THANH_TOAN_THE_TIN_DUNG_KIEU: "Type",
  CARD_THAY_DOI_HAN_MUC_GIAO_DICH_NGAY: "Change daily transaction limit",
  CARD_THE_GHI_NO: "Debit card",
  CARD_THE_TIN_DUNG: "Credit card",
  CARD_THE_TRA_TRUOC: "Prepaid card",
  CARD_THE_TRA_TRUOC_DINH_DANH: "Identifier prepaid card ",
  CARD_THE_TRA_TRUOC_VO_DANH: "Anonymous prepaid card",
  CARD_THE_GHI_NO_NOI_DIA: "Card ATM",
  CARD_THE_GHI_NO_QUOC_TE: "Card Debit Master",
  CARD_THE_PHU: "Supplementary Card",
  CARD_THE_VO_DANH_SO_TIEN_NAP_LON_HON_MUC_TOI_DA_CHO_PHEP: "The maximum recharge amount of anonymous cards is 5 millions",
  CARD_THOI_GIAN: "Date",
  CARD_THONG_BAO_CHUA_CHON_LOAI_THE: "You have not selectd card type. Please select card type to continue",
  CARD_THONG_BAO_CHUA_CHON_THE: "Please choose your card",
  CARD_THONG_BAO_EMAIL_KHONG_HOP_LE: "Email is invalidate. Please check again.",
  CARD_THONG_BAO_EMAIL_TRONG: "Please enter email",
  CARD_THONG_BAO_GIAO_DICH_ONLINE_CHUYEN_SANG_HAN_MUC_TOI_DA:
    "Do you want to increase the limit of e-commerce transactions per day of the card [card_num] to the maximum?",
  CARD_THONG_BAO_GIAO_DICH_ONLINE_CHUYEN_SANG_HAN_MUC_TOI_DA_THANH_CONG:
    "The card e-commerce transaction limit for a day [card_num] has been increased to a maximum",
  CARD_THONG_BAO_GIAO_DICH_ONLINE_CHUYEN_SANG_HAN_MUC_TOI_THIEU:
    "Do you want to reduce the limit of e-commerce transactions per day of the card [card_num] to the minimum?",
  CARD_THONG_BAO_GIAO_DICH_ONLINE_CHUYEN_SANG_HAN_MUC_TOI_THIEU_THANH_CONG:
    "The card e-commerce transaction limit for a day [card_num] has been reduced to a minimum",
  CARD_THONG_BAO_HOI_HUY_LAM_THANH_TOAN_MAC_DINH: "Would you like to unselect the account [acc_number] as the default payment source?",
  CARD_THONG_BAO_HOI_KHOA_GIAO_DICH_TRUC_TUYEN: "Are you sure you want to lock the online transaction feature of the card [card_num]?",
  CARD_THONG_BAO_HOI_KHOA_THE: "Are you sure you want to lock the card [card_num]?",
  CARD_THONG_BAO_HOI_KICH_HOAT_THE: "Do you agree to activate the card [card_num]?",
  CARD_THONG_BAO_LOI_KICH_HOAT_THE: "You have entered wrong [num1] times. Number of entries left: [num2]",
  CARD_THONG_BAO_LOI_KICH_HOAT_THE_LIMIT:
    "You have entered the wrong last 4 digits on the card more than the allowed number of times. Please come back later or contact our 24/7 Customer Service Call Center 1900 5555 92 for assistance.",
  CARD_THONG_BAO_HOI_LAM_THANH_TOAN_MAC_DINH: "Would you like to select the account [acc_number] as the default payment source?",
  CARD_THONG_BAO_HOI_MO_THE: "Are you sure you want to unlock the card [card_num]?",
  CARD_THONG_BAO_HO_VA_TEN_KHONG_KI_TU_DAC_BIET: "Please do not enter full name containing special characters except dashes and dots",
  CARD_THONG_BAO_HO_VA_TEN_TRONG: "Please enter full name",
  CARD_THONG_BAO_HUY_CHON_LAM_THANH_TOAN_MAC_DINH: "The default payment source is account [acc_number]",
  CARD_THONG_BAO_KHOA_GIAO_DICH_ONLINE_THANH_CONG: "The online transaction feature of the card [card_num] is locked.",
  CARD_THONG_BAO_KHOA_THE_THANH_CONG: "Lock the card [card_num] successfully.",
  CARD_THONG_BAO_KHONG_CO_THE_TIN_DUNG_THANH_TOAN: "You do not have a credit card. Do you want to use payment to others",
  CARD_THONG_BAO_KHONG_TON_TAI_GIAO_DICH_NAO: "No transaction",
  CARD_THONG_BAO_KICH_HOAT_GIAO_DICH_TRUC_TUYEN: "Are you sure you want to activate the online transaction feature of the card [card_num]?",
  CARD_THONG_BAO_KICH_HOAT_GIAO_DICH_TRUC_TUYEN_THANH_CONG: "The online transaction feature on [card_num] has been successfully activated",
  CARD_THONG_BAO_KICH_HOAT_THE_CREDIT_THANH_CONG: "Card [card_num] has been successfully activated.",
  CARD_THONG_BAO_KICH_HOAT_THE_DEBIT_THANH_CONG:
    "Card [card_num] has been successfully activated. Please change PIN at PVcomBank ATM to use the card.",
  CARD_THONG_BAO_KIEM_TRA_SO_THE: "Invalid card number. Please try again.",
  CARD_THONG_BAO_LAM_THANH_TOAN_MAC_DINH: "The default payment source is account [acc_number]",
  CARD_THONG_BAO_MO_KHOA_THE_THANH_CONG: "Successfully unlocked the card [card_num].",
  CARD_THONG_BAO_NGAY_BAT_DAU_KHONG_QUA_90_NGAY: "Start date and end date should not exceed 90 days.",
  CARD_THONG_BAO_NGAY_BAT_DAU_TRUOC_NGAY_KET_THUC: "Please select start date before end date.",
  CARD_THONG_BAO_NHAP_SO_THE_NAP: "Please enter card number.",
  CARD_THONG_BAO_NHAP_SO_TIEN_NAP: "Please enter amount",
  CARD_THONG_BAO_RUT_TIEN_MAT_CHUYEN_SANG_HAN_MUC_TOI_DA:
    "Do you want to increase  the daily cash withdrawal limit for your card [card_num] to the maximum?",
  CARD_THONG_BAO_RUT_TIEN_MAT_CHUYEN_SANG_HAN_MUC_TOI_DA_THANH_CONG:
    "The daily ATM withdraw limit of the card [card_num] has been increased to the maximum.",
  CARD_THONG_BAO_RUT_TIEN_MAT_CHUYEN_SANG_HAN_MUC_TOI_THIEU:
    "Do you want to reduce the daily cash withdraw limit for your card [card_num] to a minimum?",
  CARD_THONG_BAO_RUT_TIEN_MAT_CHUYEN_SANG_HAN_MUC_TOI_THIEU_THANH_CONG:
    "The daily ATM withdraw limit of the card [card_num] has been reduced to a minimum.",
  CARD_THONG_BAO_SO_DIEN_THOAI_KHONG_HOP_LE: "Phone number is not correct. Please check again.",
  CARD_THONG_BAO_SO_DIEN_THOAI_TRONG: "Please enter phone number",
  CARD_THONG_BAO_SO_TIEN_GIAO_DICH_TOI_THIEU: "Minimum transfer amount is 10,000 VND",
  CARD_THONG_BAO_TRANG_THAI_TAI_KHOAN_THANH_TOAN:
    "Payment account is inactive.  Please contact the nearest branch/Transaction office to support ",
  CARD_THONG_BAO_TRANG_THAI_TAI_KHOAN_THE: "Card account is inactive. Please contact your nearest branch / transaction office to support",
  CARD_THONG_BAO_XAC_NHAN_DIEU_KHOAN: "Please agree all terms to continue",
  CARD_THONG_BAO_YEU_CAU_PHAT_HANH_THE: "Your card issuance request is being processed. PVcomBank will contact you as soon as possible.",
  CARD_THONG_TIN_DANG_KY: "Registration information",
  CARD_THONG_TIN_GIAO_DICH: "Transaction info",
  CARD_THONG_TIN_NAP_TIEN: "Topup information",
  CARD_THONG_TIN_THE: "Card info",
  CARD_THONG_TIN_THE_PHU: "Supplementary card information",
  CARD_THU_LAI: "Retry",
  CARD_TRANG_THAI: "Status",
  CARD_TRANG_THAI_CHUA_DOI_PIN: "Not change PIN",
  CARD_TRANG_THAI_CHUA_KICH_HOAT: "Not active",
  CARD_TRANG_THAI_HOAT_DONG: "Active",
  CARD_TRANG_THAI_KHOA: "Lock",
  CARD_TRANG_THAI_TAM_KHOA: "Temporarily locked",
  CARD_TRANG_THAI_CHUA_DOI_PIN_VALID: "Card has not changed PIN",
  CARD_TRANG_THAI_CHUA_KICH_HOAT_VALID: "Card not activated",
  CARD_TRANG_THAI_KHOA_VALID: "Card is locked",
  CARD_TRANG_THAI_TAM_KHOA_VALID: "Card is temporarily locked",
  CARD_TRA_SOAT_GIAO_DICH: "Dispute transactions",
  CARD_TRUY_VAN: "Inquiry",
  CARD_VUI_LONG_NHAP_SO_DIEN_THOAI: "Please enter phone number",
  CARD_XAC_NHAN_NAP_TIEN: "Topup confirm",
  CARD_XEM_CHI_TIET_THE: "View card detail",
  CARD_CVV_NOTE: "To make online transaction, you need to display card number and dynamic CVV number.",
  CARD_CVV_NOTE_TIME_COUNT_DOWN: "Dynamic CVV expires after",
  CARD_CVV_DONG: "Number of dynamic CVV",
  CARD_CVV_ASK_AGAIN: "Do not show again",
  CARD_TRANG_THAI_GD_THANH_CONG: "Transaction was successful",
  CARD_TRANG_THAI_GD_KHONG_THANH_CONG: "Transaction not completed",
  CARD_TRANG_THAI_TK_HET_HAN: "Account expires",
  CARD_TRANG_THAI_TK_KHONG_XAC_DINH: "Could not identify account",

  CASH_BY_CODE_4_MA_DAU: "First 4 codes",
  CASH_BY_CODE_BEN_CHIU_PHI: "Charged",
  CASH_BY_CODE_BEN_CHUYEN: "Transferor",
  CASH_BY_CODE_CHI_TIET_PHI: "Fee details",
  CASH_BY_CODE_DONG: "Close",
  CASH_BY_CODE_GIAO_DICH_KHAC: "Other transactions",
  CASH_BY_CODE_GIAO_DICH_THANH_CONG: "Transaction success",
  CASH_BY_CODE_HET_HIEU_LUC: "Expire",
  CASH_BY_CODE_HIEU_LUC_DEN: "Valid till",
  CASH_BY_CODE_HUONG_DAN:
    "The function allows transferring money to the recipient by a code sent via phone number. The beneficiary does not need an account at the Bank. The recipient uses the receiving account number (generated by the system) and the code (including the first 4 codes and the last 4 codes) to withdraw money at PVcomBank's ATM. The first 4 codes are sent to the sender. Last 4 codes and account number are sent to the recipient.",
  CASH_BY_CODE_HUY: "Cancel",
  CASH_BY_CODE_KET_THUC: "Finish",
  CASH_BY_CODE_KHONG_HOI_LAI_LAN_NUA: "Do not display again",
  CASH_BY_CODE_LIST_HISTORY: "Transaction history",
  CASH_BY_CODE_LUU_Y_SDT_PHAI_LIEN_KET: "Note: Phone number has must register SMS Banking service at PVcomBank",
  CASH_BY_CODE_NHAP_SO_TIEN_LA_BOI_SO_10000: "Please enter amount that is a multiple of 10,000 VND.",
  CASH_BY_CODE_NHAP_THIEU_SO_DIEN_THOAI: "Please enter phone number of recipient",
  CASH_BY_CODE_NOTE_CHUYEN_NHANH_THU_HUONG: "To transfer money faster and do not need to remember the information?",
  CASH_BY_CODE_SO_DIEN_THOAI_KHONG_HOP_LE: "Phone number is incorrect. Please check again.",
  CASH_BY_CODE_SO_DIEN_THOAI_NHAN_4_MA_CUOI: "Phone number of recipient",
  CASH_BY_CODE_SO_DIEN_THOAI_NHAN_4_MA_DAU: "Phone number receives the first 4 codes",
  CASH_BY_CODE_SO_TAI_KHOAN: "Account number",
  CASH_BY_CODE_SO_TIEN: "Amount",
  CASH_BY_CODE_TAI_KHOAN_CHUYEN: "Transfer account",
  CASH_BY_CODE_TAI_KHOAN_THANH_TOAN: "Payment account",
  CASH_BY_CODE_THEM_VAO_THU_HUONG: "Add to beneficiary list",
  CASH_BY_CODE_THOI_GIAN_GIAO_DICH: "Transaction time",
  CASH_BY_CODE_THONG_BAO_CUNG_CAP_4_MA_DAU_CHO_NGUOI_NHAN: "You provide the first 4 codes to the recipient to make a withdrawal.",
  CASH_BY_CODE_THONG_BAO_KHONG_TON_TAI_GIAO_DICH_NAO: "No transaction",
  CASH_BY_CODE_THONG_BAO_NGAY_BAT_DAU_KHONG_QUA_90_NGAY: "Start date and end date should not exceed 90 days.",
  CASH_BY_CODE_THONG_BAO_NGAY_BAT_DAU_TRUOC_NGAY_KET_THUC: "Please select start date before end date.",
  CASH_BY_CODE_THONG_BAO_TRANG_THAI_TAI_KHOAN_CHUYEN: "The transfer account is inactive. Please contact the nearest branch for support.",
  CASH_BY_CODE_THONG_TIN_GIAO_DICH: "Transaction info",
  CASH_BY_CODE_TIEP_TUC: "Enter",
  CASH_BY_CODE_TITLE: "Cash by code",
  CASH_BY_CODE_TONG_PHI: "Total fee",
  CASH_BY_CODE_TRANG_THAI: "Status",
  CASH_BY_CODE_TRA_SOAT: "Dispute",
  CASH_BY_CODE_TRUY_VAN: "Inquiry",
  CASH_BY_CODE_VUI_LONG_NHAP_SO_TIEN: "Please enter transfer amount.",
  CASH_BY_CODE_XEM: "View",

  CHART_HEALTH_CAP_NHAT_NGUONG_AN_TOAN: "Set the desired maintenance balance",
  CHART_HEALTH_DONG_Y: "Agree",
  CHART_HEALTH_GIA_TRI_MUC_MAX_KHONG_DUOC_TRONG: "Maximum value is not blank",
  CHART_HEALTH_GIA_TRI_MUC_MIN_KHONG_DUOC_TRONG: "Minimum value is not blank",
  CHART_HEALTH_GIA_TRI_NGUONG_AN_TOAN_KHONG_HOP_LE: "The minimum must not be greater than or equal to the maximum",
  CHART_HEALTH_HUY: "Cancel",

  COMMON_BAT_DAU_SU_DUNG: "Starting to use",
  COMMON_TAI_VE: "Download",
  COMMON_CHO_PHEP_QUYEN_TRUY_CAP_DANH_BA: "Please access Settings - Application on device to grant contacts access to the application.",
  COMMON_CHO_PHEP_TRUY_CAP: "Allow access",
  COMMON_CHUC_NANG_SAP_RA_MAT: "Functions under development.",
  COMMON_CHUP_ANH: "Take a photo",
  COMMON_CHU_THICH: "Note",
  COMMON_CHU_THICH_CHUA_BAT_FACE_ID_TREN_THIET_BI: "You can login by face ID. Go to Device settings to set face recognition",
  COMMON_CHU_THICH_CHUA_BAT_VAN_TAY_TREN_THIET_BI: "You can login with fingerprint. Go to install device to install fingerprint",
  COMMON_CHU_THICH_FACE_LAN_DAU: "You can login by face ID. Access the utilities function to activate",
  COMMON_CHU_THICH_VAN_TAY_LAN_DAU: "You can login by fingerprint. Access the utilities function to activate",
  COMMON_DANG_KY_DICH_VU: "Auto transfer",
  COMMON_DANH_SACH_TAI_KHOAN: "Account list",
  COMMON_DEN_NGAY: "To date",
  COMMON_DICH_VU_DANG_DUOC_PHAT_TRIEN: "Service is under development",
  COMMON_DICH_VU_KHONG_CO_NHA_CUNG_CAP: "{dich_vu} No provider",
  COMMON_DONG: "Close",
  COMMON_DONG_Y: "Agree",
  COMMON_GIAO_DICH_KHAC: "Other transactions",
  COMMON_GIAO_DICH_THANH_CONG: "Transaction success",
  COMMON_DANG_KY_THANH_CONG: "Registration successful",
  COMMON_GIOI_THIEU: "Introduction",
  COMMON_HOAC_DANG_NHAP_KHUON_MAT: "or Login by face ID",
  COMMON_HOAC_DANG_NHAP_VAN_TAY: "or Login by fingerprint",
  COMMON_HOTLINE_MENU: "Hotline: 1900 5555 92",
  COMMON_HO_TEN: "Full name",
  COMMON_HO_TRO_KH: "Customer support",
  COMMON_HUY: "Cancel",
  COMMON_QUAY_LAI: "Back",
  COMMON_KET_THUC: "Finish",
  COMMON_KHAC_CHU_TAI_KHOAN: "The other CIF",
  COMMON_KHOAN_VAY: "Loan",
  COMMON_KHONG_CO_DANH_BA: "No Contacts",
  COMMON_KHONG_CO_DU_LIEU: "No data",
  COMMON_KHONG_CO_MANG: "No internet",
  COMMON_KHONG_TON_TAI_SDT: "No phone number exits.",
  COMMON_LICH_SU_NOP_THEM_TIEN: "Deposit history",
  COMMON_LICH_SU_TRA_SOAT: "History of dispute transaction",
  COMMON_LOI_KHONG_KET_NOI_DUOC_MAY_CHU: "There was an error connecting. Please check your network connection.",
  COMMON_LOI_KHONG_KET_NOI_DUOC_MAY_CHU_NGUNG_GIAO_DICH:
    "There was an error connecting. Please check your network connection and cancel this function",
  COMMON_LOI_TOUCH_ID_DA_DOI_MAT_KHAU:
    "Your password has been changed. Please login with your new password and enable fingerprint login function in the Utilities.",
  COMMON_MAIN_BOTTOM: "© 2019 - PVcomBank",
  COMMON_MA_OTP: "OTP code",
  COMMON_MA_OTP_HET_HIEU_LUC: "The transaction was canceled because the time limit for entering the verification code has expired.",
  COMMON_MOT_NGAY: "day",
  COMMON_MOT_THANG: "month",
  COMMON_MOT_TUAN: "week",
  COMMON_NAP_TIEN: "Topup",
  COMMON_HOA_DON: "Billing",
  COMMON_NGAN_HANG_TMCP_DAI_CHUNG_VIET_NAM: "Vietnam Public Joint Stock Commercial Bank",
  COMMON_NGON_NGU_HIEN_THI: "Display language",
  COMMON_NHAN_THEM_LAN_NUA_DE_THOAT: "Click again to exit",
  COMMON_NHAP_MA_OTP: "Enter OTP code",
  COMMON_NHAP_MA_OTP_TIEU_DE: "Please enter OTP code to verify. The OTP expires in ",
  COMMON_NHAP_MA_SMART_OTP_TIEU_DE: "The OTP expires in",
  COMMON_NHIEU_NGAY: "days",
  COMMON_NHIEU_THANG: "months",
  COMMON_NHIEU_TUAN: "weeks",
  COMMON_NOI_DUNG_MO_CAMERA_SETTING: "Please go to Settings - Application on your devices to allow this app to access camera.",
  COMMON_NOI_DUNG_MO_LIBRARY_SETTING: "Please go to Settings - Application on your devices to allow this app to access photos.",
  COMMON_NOI_DUNG_MO_STORAGE_SETTING: "Please go to Settings - Application on your devices to allow this app to access storage.",
  COMMON_NOTE_CHON_NGON_NGU: "You can change the language in utilities",
  COMMON_NOTE_CHUP_ANH_HOAC_THU_VIEN: "Take a photo or choose from the gallery",
  COMMON_PHIEN_BAN: "Mobile Banking - Version 2.5",
  COMMON_PHIEN_BAN_APP: "© 2019 - PVcomBank",
  COMMON_PHIEN_BAN_IB: "Copyright © 2021 of PVcomBank",

  COMMON_PHIEN_GIAO_DICH: "Transaction session",
  COMMON_QR: "QR Pay",
  COMMON_SAO_KE_GIAO_DICH: "Statement",
  COMMON_TAI_KHOAN: "Account",
  COMMON_TAO_GIAO_DICH_MOI: "Create new transaction",
  COMMON_TAO_GIAO_DICH_TU_DANH_SACH_THU_HUONG: "Create new transaction from beneficiary list",
  COMMON_TEN_CHI_NHANH_DIA_CHI: "Branch / Address name",
  COMMON_THANH_TOAN_HOA_DON: "Payment billing",
  COMMON_THAY_DOI_ANH_DAI_DIEN: "Change avatar",
  COMMON_THEM_VAO_DANH_SACH_THU_HUONG: "Add to beneficiary list",
  COMMON_THOAT: "Log out",
  COMMON_THONG_BAO: "Notification",
  COMMON_THONG_BAO_CAP_NHAT_PBPM:
    "PV Mobile Banking has new version. Please update soon for experience our new app with many exciting utilities.",
  COMMON_THONG_BAO_CHUA_DK_PHUONG_THUC_XAC_THUC: "You have not registered an authentication method",
  COMMON_THONG_BAO_HET_PHIEN: "Your session has expired, please login to continue.",
  COMMON_THONG_BAO_KHONG_CO_TAI_KHOAN_KICH_HOAT: "Your account is inactive. Please come to the PVcomBank counters to support.",
  COMMON_THONG_BAO_LOI_CHUNG: "There was an error during processing. Please try again later.",
  COMMON_THONG_BAO_QUA_HAN_MUC_GD_NGAY: "Over limit total transaction amount for one day",
  COMMON_THONG_BAO_THAY_DOI_FACE_ID_THIET_BI: "Your {func} function has been automatically stopped due to FaceID change on the device.",
  COMMON_THONG_BAO_THAY_DOI_FACE_ID_THIET_BI_2_FUNC:
    "Your functions {func_1} and {func_2} have been automatically stopped due to FaceID change on the device.",
  COMMON_THONG_BAO_THAY_DOI_VAN_TAY_THIET_BI:
    "Your {func} function has been automatically stopped due to a change in Fingerprint on the device.",
  COMMON_THONG_BAO_THAY_DOI_VAN_TAY_THIET_BI_2_FUNC:
    "Your {func_1} and {func_2} functions have been automatically stopped due to a change in Fingerprint on the device.",
  COMMON_THONG_BAO_CAI_DAT_FUNC_BEFORE_LOGIN: "Please re-enable this function after logging in.",
  COMMON_THONG_BAO_CAI_DAT_FUNC_SETTING: "Please go to Add-ons to re-enable this function.",
  COMMON_THONG_BAO_TRANG_THAI_TAI_KHOAN_THANH_TOAN:
    "Payment account is inactive.  Please contact the nearest branch/Transaction office to support.",
  COMMON_THONG_TIN_NGAN_HANG: "Bank Information",
  COMMON_THU_VIEN: "Gallery",
  COMMON_TIENG_ANH: "English",
  COMMON_TIENG_VIET: "Vietnamese",
  COMMON_TIEN_ICH: "Utility",
  COMMON_TUY_CHINH: "Custom",
  COMMON_TIEP_TUC: "Continue",
  COMMON_TIET_KIEM: "ESaving",
  COMMON_TIM_KIEM: "Search",
  COMMON_TIM_KIEM_ATM: "Search for ATM/Branches",
  COMMON_TIM_KIEM_ATM_CN: "Search for ATM/Branches",
  COMMON_TK: "Account",
  COMMON_TONG_SO_DU_THE: "Credit card balance",
  COMMON_TONG_SO_DU_TKTK: "Saving account",
  COMMON_TONG_SO_DU_TKTT: "Payment account",
  COMMON_TONG_SO_DU_TKTV: "Loan",
  COMMON_TRA_SOAT_GIAO_DICH: "Dispute transactions",
  COMMON_TU_NGAY: "From date",
  COMMON_VERSION_MENU: "Version {version} - 2019 PVcomBank",
  COMMON_VUI_LONG_NHAP_OTP: "Please enter OTP code",
  COMMON_XAC_NHAN: "Confirm",
  COMMON_XAC_THUC_OTP: "Confirm",
  COMMON_XOA: "Delete",
  COMMON_QUY_KHACH_THAY_DOI_MAT_KHAU_PVCONNECT: "PVConnect has been changed. Please login again",
  COMMON_THONG_TIN_TAI_KHOAN: "Account infomation",
  COMMON_THONG_TIN_GIAO_DICH: "Transaction infomation",
  COMMON_CHAO_MUNG_QUY_KHACH: "Welcome to Digital Bank",
  COMMON_LUU_Y_CHO_KHACH_HANG: "Small notes for customers",
  COMMON_NOTE_1: "For customers who already have an Internet Banking account:",
  COMMON_NOTE_2: "Username is the CIF number",
  COMMON_NOTE_3: "For customers who already have a PVcomBank Connect account:",
  COMMON_NOTE_4: "Username is the phone number which has been registered service",
  COMMON_IN: "Print",
  COMMON_THU_VIEN_QR: "QR Library",
  COMMON_DINH_DANH_GD: "Transaction identifier",
  COMMON_MA_GD: "Transaction code",
  COMMON_NHAP_MA_XA_THUC: "Enter authentication code",
  COMMON_QUET_LAY_MA_XA_THUC: "Scan to get authentication code",
  COMMON_HUONG_DAN_XAC_THUC: "See detailed instructions",
  COMMON_TAI_DAY: "here",
  COMMON_HUONG_DAN: "Instructions",
  COMMON_XAC_THUC_GD: "Verify transaction",
  COMMON_BANG_CHU: "In words",
  COMMON_IN_BIEN_LAI: "Print receipt",
  COMMON_CHIA_SE: "Sharing",
  COMMON_NOTE_DESCRIPTION: "Unsigned content, no special characters",
  COMMON_OTP_CHUA_NHAP: "Please enter OTP code",
  COMMON_OTP_KHONG_HOP_LE: "Invalid OTP",
  COMMON_VND: "VND",
  COMMON_SO_TIEN_KHONG_DUOC_DUOI_10000D: "Minimum transfer amount is 10,000 VND",
  COMMON_TEN_NHDCVN: "Ngân hàng TMCP Đại Chúng Việt Nam",
  COMMON_NAM: "Year",
  COMMON_SO_DONG_PAGE: "Number of lines per page",
  COMMON_PAGE: "Page",
  COMMON_LOI: "Oops!",
  COMMON_KHAM_PHA_NGAY: "Discover Now",
  COMMON_KHAO_SAT_NGAY: "Survey now",
  COMMON_THONG_BAO_CHUC_NANG_DOI_MK: "Function is being upgraded, please access PV Mobile Banking application to do it.",
  COMMON_GIAY_BAO_CO: "Credit report",
  COMMON_GIAY_BAO_NO: "Debit report",
  COMMON_KHONG_TIM_THAY_TIM_KIEM: "The requested result was not found",
  COMMON_XEM: "Show",
  COMMON_QUY_KHACH_MUON_HUY_GIAO_DICH: "Do want to cancel this transaction?",
  COMMON_NOTE_KHONG_BAT_BUOC: "Optional content",
  COMMON_THONG_BAO_CHUC_NANG_TAM_KHOA: "This service is temporarily unavailable. For further support, please contact our Call Center 24/7: 1900 5555 92 or the nearest PVcomBank branch.",
  COMMON_THONG_BAO_LOCK_PVCONNECT_APP_TITLE: "IMPORTANT UPDATE",
  COMMON_THONG_BAO_LOCK_PVCONNECT_APP: "Please access the PVConnect application to continue to use Digital Banking services.",
  COMMON_THONG_BAO_FORCE_PVCONNECT_APP_TITLE: "ULTIMATE EXPERIENCE WITH PVCONNECT",
  COMMON_THONG_BAO_FORCE_PVCONNECT_APP: "PVConnect is now officially available for you to download. PVcomBank is going to discontinue PV Mobile Banking application to customers.Please access the PVConnect application to continue using Digital Banking services.",
  COMMON_TOI_DA_HIEU: "I understand",
  COMMON_QUET_QR: "Scan QR",
  COMMON_QUET_QR_UPDATE: "to download PVConnect application",

  DETAIL_QR_CHIT_TIET_GIAO_DICH: "Transaction details",
  DETAIL_QR_DIEM_BAN: "Point of salse",
  DETAIL_QR_GHI_CHU: "Note",
  DETAIL_QR_SO_HOA_DON: "Billing number",
  DETAIL_QR_SO_TIEN_THANH_TOAN: "Payment amount",
  DETAIL_QR_TAI_KHOAN_NGUON: "Source account",
  DETAIL_QR_THANH_TOAN_CHO: "Payment for",
  DETAIL_QR_THOI_GIAN_GIAO_DICH: "Transaction time",

  FEE_BEN_CHIU_PHI: "Charged",
  FEE_BEN_CHUYEN: "Transferor",
  FEE_BEN_NHAN: "Receiver",
  FEE_CHI_TIET_PHI: "Fee detail",
  FEE_GIAM_PHI: "Fee reduced",
  FEE_PHI: "Fee",
  FEE_TONG: "Total",
  FEE_TONG_GHI_NO: "Total debit",
  FEE_TONG_PHI: "Total fee",
  FEE_TONG_THUC_CHUYEN: "Real transfer",
  FEE_VAT: "VAT",
  FEE_XEM: "View",
  FEE_BIEU_PHI: "Fee Schedule",

  FUNC_BOTTOM_QR_PAY: "QR Pay",
  FUNC_BOTTOM_TIM_KIEM_ATM_CN: "ATM/Branches",
  FUNC_BOTTOM_TU_VAN_TAI_CHINH: "Consult",
  FUNC_BOTTOM_UU_DAI: "Promotions",
  FUNC_BOTTOM_LAY_MA_OTP: "Get OTP",
  FUNC_CASH_BY_CODE: "Cash by code",
  FUNC_CHUNG_KHOAN: "Transfer to{new_line}PSI account",
  FUNC_DANG_KY_VAY_VON: "Loan registration",
  FUNC_DAU_TU: "Invest",
  FUNC_DIEN_THOAI: "Phone",
  FUNC_DS_KHOAN_VAY: "Loan list",
  FUNC_DS_THE: "Card list",
  FUNC_DV_GIAO_DICH_TU_DONG: "Auto transaction",
  FUNC_DV_KHAC: "Other services",
  FUNC_DV_NAP_TIEN: "Topup",
  FUNC_DV_THANH_TOAN: "Payment",
  FUNC_DV_THANH_TOAN_HOA_DON: "Billing payment",
  FUNC_HD_ADSL: "ADSL",
  FUNC_HD_ADSL_VNPT: "ADSL - VNPT",
  FUNC_HD_DIEN: "Electric",
  FUNC_HD_INTERNET_TV: "Internet TV",
  FUNC_HD_LEADED_LINE: "Leased-line",
  FUNC_HD_NUOC: "Water",
  FUNC_HD_TRUYEN_HINH: "TV",
  FUNC_HD_TRUYEN_HINH_VNPT: "VNPT TV",
  FUNC_HD_VE_MAY_BAY: "Airline bill",
  FUNC_KHOA_MO_GD_TRUC_TUYEN: "Lock/Unlock{new_line}online transaction",
  FUNC_LICH_SU_GIAO_DICH: "Transaction{new_line}history",
  FUNC_LOYALTY: "Loyalty",
  FUNC_LS_VAY: "History",
  FUNC_MAIN_CHUYEN_TIEN_CHUNG_KHOAN: "Investment{new_line}stock",
  FUNC_MAIN_DAU_TU: "Invest",
  FUNC_MAIN_DICH_VU_THANH_TOAN: "Payment",
  FUNC_MAIN_QUAN_LY_TAI_KHOAN: "Manage{new_line}account",
  FUNC_MAIN_TIET_KIEM_DIEN_TU: "Saving{new_line}online",
  FUNC_MAIN_TIM_KIEM_ATM_CN: "ATM/Branches",
  FUNC_MAIN_TU_VAN_GUI_TIET_KIEM: "Saving{new_line}advice",
  FUNC_MAIN_TU_VAN_TAI_CHINH: "Finance{new_line}advice",
  FUNC_MAIN_VAY_TRUC_TUYEN: "Loan",
  FUNC_MAIN_ONLINE_LOAN: "Online loan",
  FUNC_MAIN_ONLINE_LOAN_CREATE: "Create online loan",
  FUNC_MAIN_ONLINE_LOAN_TERMINATE: "Terminate online loan",
  FUNC_MO_SO_TK: "Create deposit",
  FUNC_NAP_TIEN_TU_DONG: "Topup",
  FUNC_NAP_TIEN_VE_MAY_BAY: "Topup{new_line}airline ticket",
  FUNC_NGOAI_PVCB: "Interbank transfer",
  FUNC_NHANH_24_7: "Received immediately",
  FUNC_NOP_THEM_STK: "Deposits",
  FUNC_PHAT_HANH_THE_VAT_LY: "Issue {new_line} physical tags",
  FUNC_QR_PAY: "QR pay",
  FUNC_TAT_TOAN_STK: "Final settlement",
  FUNC_THANH_TOAN: "Payment",
  FUNC_THANH_TOAN_HOA_DON_TU_DONG: "Auto{new_line}billing",
  FUNC_THANH_TOAN_THE_TIN_DUNG: "Credit card payment",
  FUNC_THONG_TIN_KHOAN_VAY: "Loan information",
  FUNC_THU_HUONG: "Beneficiary",
  FUNC_TIEN_ICH: "Utilities",
  FUNC_TIEN_ICH_QUICK: "Quick Utility",
  FUNC_TIET_KIEM: "Saving",
  FUNC_TIET_KIEM_DIEN_TU: "Saving online",
  FUNC_TIET_KIEM_TRUC_TUYEN: "Online Savings",
  FUNC_TRANG_CHU: "Home",
  FUNC_TRONG_PVCB: "The same bank",
  FUNC_TU_VAN_GUI_TIET_KIEM: "Finance advice",
  FUNC_TU_VAN_MO_SO_TK: "Deposit advice",
  FUNC_TU_VAN_TAI_CHINH: "Finance advice",
  FUNC_UU_DAI: "Promotions",
  FUNC_VAY_TRUC_TUYEN: "Loan",
  FUNC_BOTTOM_HUONG_DAN_SU_DUNG: "User Manual",
  FUNC_BOTTOM_HUONG_DAN_BAO_MAT: "Security Guide",
  FUNC_BOTTOM_CAU_HOI_THUONG_GAP: "Frequently Asked Questions",
  FUNC_PV_ONE: "PVOne",
  FUNC_LIEN_KET_NHANH: "Quick links",
  FUNC_HO_TRO: "Support",
  FUNC_DICH_VU: "Services",
  FUNC_TINH_NANG: "Features",

  HISTORY_QR_CHON_TAI_KHOAN: "Account list",
  HISTORY_QR_CHO_THANH_TOAN: "Wait for payment",
  HISTORY_QR_DANG_THUC_HIEN_THANH_TOAN: "Paying",
  HISTORY_QR_DANG_XU_LY: "Processing",
  HISTORY_QR_KHONG_DU_SO_DU: "Not enough balance",
  HISTORY_QR_NGUON_THANH_TOAN: "Payment source",
  HISTORY_QR_NHA_CUNG_CAP: "Provider",
  HISTORY_QR_SO_TIEN: "Amount",
  HISTORY_QR_TAT_CA_TAI_KHOAN: "All account",
  HISTORY_QR_THANH_TOAN_THANH_CONG: "Success",
  HISTORY_QR_THANH_TOAN_THAT_BAI: "Transaction fail",
  HISTORY_QR_THE_GHI_NO: "Debit card",
  HISTORY_QR_THE_THANH_TOAN: "Payment account",
  HISTORY_QR_THE_TIN_DUNG: "Credit card",
  HISTORY_QR_THE_TRA_TRUOC: "Prepaid card",
  HISTORY_QR_THOI_GIAN_GIAO_DICH: "Transaction time",
  HISTORY_QR_THONG_BAO_KHONG_TON_TAI_GIAO_DICH_NAO: "No transaction",
  HISTORY_QR_THONG_BAO_NGAY_BAT_DAU_KHONG_QUA_90_NGAY: "Date and time must be within 90 days",
  HISTORY_QR_THONG_BAO_NGAY_BAT_DAU_TRUOC_NGAY_KET_THUC: "From date must be less than To date",
  HISTORY_QR_TITLE: "QR transaction history",
  HISTORY_QR_TRANG_THAI: "Status",
  HISTORY_QR_TRA_SOAT: "Dispute",
  HISTORY_QR_TRUY_VAN: "Inquiry",

  INFOMATION_DIA_CHI: "No. 22 Ngo Quyen Street, Trang Tien Ward,Hoan Kiem District, Hanoi, Vietnam",
  INFOMATION_DIEN_THOAI: "(+84) 02439426800",
  INFOMATION_DIEN_THOAI_HO_TRO: "1900 5555 92",
  INFOMATION_EMAIL: "pvb@pvcombank.com.vn",
  INFOMATION_FAX1: "(+84) 02439426796",
  INFOMATION_FAX2: "(+84) 02439426797",
  INFOMATION_WEBSITE: "www.pvcombank.com.vn",

  INSTRUCTION_CHANGE_TRANS_LIMIT: "Change transaction limit package",
  INSTRUCTION_CHUYEN_TIEN: "Transfer",
  INSTRUCTION_DANG_KY_NAP_TIEN_TU_DONG: "Auto topup register",
  INSTRUCTION_DANG_KY_THANH_TOAN_HOA_DON_TU_DONG: "Auto billing register",
  INSTRUCTION_DANG_NHAP: "Log-in",
  INSTRUCTION_DICH_VU_THE: "Card service",
  INSTRUCTION_LOYALTY: "Loyalty",
  INSTRUCTION_NAP_TIEN_DIEN_THOAI: "Topup",
  INSTRUCTION_QUAN_LY_TAI_KHOAN: "Account manager",
  INSTRUCTION_SMART_CAI_DAT_FACEID: "Install FaceID",
  INSTRUCTION_SMART_CAI_DAT_VAN_TAY: "Install TouchID",
  INSTRUCTION_SMART_CHUYEN_THIET_BI: "Change device activated Smart OTP",
  INSTRUCTION_SMART_DANG_KY: "Smart OTP Register",
  INSTRUCTION_SMART_DOI_PIN: "Change PIN",
  INSTRUCTION_SMART_KHOI_PHUC_PIN: "PIN recovery",
  INSTRUCTION_SMART_KICH_HOAT: "Smart OTP Activated",
  INSTRUCTION_SMART_LAY_MA_XAC_THUC: "Get the OTP authentication code",
  INSTRUCTION_SMART_MAT_THIET_BI_KICH_HOAT_LAI: "Device Lost/Reactivate",
  INSTRUCTION_SMART_XOA_FACEID: "Delete FaceID",
  INSTRUCTION_SMART_XOA_VAN_TAY: "Delete TouchID",
  INSTRUCTION_THANH_TOAN_HOA_DON: "Billing payment",
  INSTRUCTION_THANH_TOAN_QR: "QR Pay",
  INSTRUCTION_THANH_TOAN_THE_TIN_DUNG: "Credit card payment",
  INSTRUCTION_THU_HUONG: "Beneficiary",
  INSTRUCTION_TIEN_ICH: "Utilities",
  INSTRUCTION_TIET_KIEM_ONLINE: "Saving online",
  INSTRUCTION_TIM_KIEM_ATM_CN: "Search ATM/Branch",
  INSTRUCTION_TRA_SOAT_GD: "Investigation of transactions",
  INSTRUCTION_TU_VAN_GUI_TIET_KIEM: "Deposit advice",
  INSTRUCTION_UU_DAI: "Promotions",

  LOAN_CHI_NHAN_HO_TRO_LAM_HO_SO: "Branch support record",
  LOAN_CHI_TIET_LICH_TRA_NO: "Payment schedule details",
  LOAN_DANG_KY: "Sign",
  LOAN_DANH_SACH_KHE_UOC: "Loan information",
  LOAN_DU_NO_CON_LAI: "Balance outstanding",
  LOAN_DU_NO_GOC: "Origin balance",
  LOAN_HO_TEN: "Full name",
  LOAN_HUY: "Cancel",
  LOAN_KHONG_CO_KHE_UOC: "No contract",
  LOAN_KHONG_CO_LS_TRA_NO: "There is no payment history",
  LOAN_KY_HAN: "Term",
  LOAN_LAI_SUAT: "Interest",
  LOAN_LICH_SU_TRA_NO: "Payment history",
  LOAN_MUC_DICH_VAY: "Loan purpose",
  LOAN_NGAY: "Date",
  LOAN_NGAY_HET_HAN: "Release date",
  LOAN_NGAY_HIEU_LUC: "Effective date",
  LOAN_NHAP_THIEU_HO_TEN: "Please enter full name",
  LOAN_NHAP_THIEU_SO_DIEN_THOAI: "Please enter contact phone number",
  LOAN_SO_DIEN_THOAI: "Contact phone number",
  LOAN_SO_DIEN_THOAI_KHONG_HOP_LE: "Phone number isnot correct. Please check again.",
  LOAN_SO_KHE_UOC: "Contract number",
  LOAN_THOI_GIAN: "Time",
  LOAN_THONG_TIN_KHOAN_VAY: "Loan information",
  LOAN_TIM_THAY_KHE_UOC: "The contract was not found",
  LOAN_TITLE: "Loan register",
  LOAN_TRUY_VAN: "Inquiry",

  LOYALTY_ALL: "All",
  LOYALTY_AP_DUNG: "Apply",
  LOYALTY_CHECK_QUA_CO_THE_DOI: "Show only deals I can redeem",
  LOYALTY_CHI_TIET_DOI_QUA: "Confirm",
  LOYALTY_DANH_MUC: "Category",
  LOYALTY_DANH_SACH_QUA_TANG: "Gift list",
  LOYALTY_DA_HET_QUA: "Out of Gift",
  LOYALTY_DK_THE: "Register Card",
  LOYALTY_DIEM: "Points",
  LOYALTY_DIEM_CAO_THAP: "High points to low points",
  LOYALTY_DIEM_CON_LAI: "The rest",
  LOYALTY_DIEM_DOI_QUA: "Redeem points",
  LOYALTY_DIEM_HET_HAN_TIME: "Will expire on {date}",
  LOYALTY_DIEM_QUY_DOI: "Redemption points",
  LOYALTY_DIEM_SAN_CO: "Availability points",
  LOYALTY_DIEM_SE_QUY_DOI: "Points will be redeemed",
  LOYALTY_DIEM_THAP_CAO: "Low points to high",
  LOYALTY_DIEM_THUONG_CO_SAN: "Bonus points available",
  LOYALTY_DIEU_KHOAN_DIEU_KIEN: "Terms and conditions",
  LOYALTY_DOI_QUA: "Gift redemption",
  LOYALTY_DOI_QUA_KHONG_THANH_CONG: "The redemption registration failed",
  LOYALTY_DOI_QUA_THANH_CONG: "Register to redeem successfully",
  LOYALTY_DOI_QUA_THANH_CONG_NOTE_1: "Your redemption request has been received with the request code",
  LOYALTY_DOI_QUA_THANH_CONG_NOTE_2: "Please check the status of redemption at the electronic channel or contact",
  LOYALTY_DONE: "Done",
  LOYALTY_IN: "In",
  LOYALTY_KHONG_CO_LS_DOI_QUA: "No transaction occurred",
  LOYALTY_KHONG_CO_LS_GIAO_DICH: "No transaction has occurred",
  LOYALTY_KHONG_CO_QUA: "No Gift",
  LOYALTY_KHONG_TIM_THAY_QUA: "Gift not found according to filter condition",
  LOYALTY_LICH_SU_DOI_QUA: "Gift history",
  LOYALTY_LICH_SU_GIAO_DICH: "Bonus point history",
  LOYALTY_LIEN_HE: "Contact",
  LOYALTY_LOC: "Filter",
  LOYALTY_LOC_THEO: "Filter by",
  LOYALTY_LOC_VA_PHAN_LOAI: "Filtering and Classifying",
  LOYALTY_LOI_CHUA_NHAP_DIA_CHI: "Please enter your address",
  LOYALTY_LOI_CHUA_NHAP_EMAIL: "Please enter your email",
  LOYALTY_LOI_CHUA_NHAP_SO_DIEN_THOAI: "Please enter your phone number",
  LOYALTY_LOI_EMAIL_KHONG_HOP_LE: "Invalid email",
  LOYALTY_LOI_KHONG_DU_DIEM: "Not enough points",
  LOYALTY_LOI_MA_THANH_VIEN_VINID: "Please enter only the member code VINID with 16 digits",
  LOYALTY_LOI_NHAP_MA_THANH_VIEN_VINID: "Please enter your VINID membership code",
  LOYALTY_LOI_NHAP_SO_THE_HOI_VIEN_BSV: "Please enter your Bong Sen Vang membership number",
  LOYALTY_LOI_NHAP_STK_THANH_TOAN: "Please enter your account number",
  LOYALTY_LOI_SO_DIEN_THOAI_KHONG_HOP_LE: "Invalid phone number",
  LOYALTY_LOI_SO_THE_HOI_VIEN_BSV: "Please enter only the Bong Sen Vang membership number with 8/10 digits",
  LOYALTY_MA_THANH_VIEN_VINID: "VinID Membership ID",
  LOYALTY_MA_YEU_CAU: "Request Code",
  LOYALTY_MOI_NHAT: "Newest",
  LOYALTY_NHAP_DIA_CHI: "Address",
  LOYALTY_NHAP_EMAIL: "Email",
  LOYALTY_NHAP_SO_DIEN_THOAI: "Phone number",
  LOYALTY_NOI_DUNG_UU_DAI: "Offer content",
  LOYALTY_NOTE_LOCK_CBNV:
    "PVcomBank will officially launch the Gift Redemption Program for loyal customers in 2020 and will inform customers as soon as possible. Thank you for your companion and use of our translation products. PVcomBank's service.For more information, please contact: {hot_line}. ",
  LOYALTY_NOTE_HOT_LINE: "1900555592",
  LOYALTY_OUT: "Out",
  LOYALTY_PHAN_LOAI_THEO: "Sort by",
  LOYALTY_PHO_BIEN: "Popular",
  LOYALTY_PROGRAM: "Loyal customers",
  LOYALTY_SO_DIEN_THOAI_LIEN_HE: "1900 5555 92",
  LOYALTY_SO_LUONG: "Quantity",
  LOYALTY_SO_THE_HOI_VIEN_BSV: "Golden Lotus Membership Number",
  LOYALTY_STK_THANH_TOAN_NHAN_TIEN: "Payment account number receiving money",
  LOYALTY_TAT_CA: "All",
  LOYALTY_TEN_QUA: "Gift name",
  LOYALTY_THE_LE: "Rules",
  LOYALTY_THONG_BAO_HOI_HUY_DOI: "Are you sure you want to Cancel the redemption of gift points?",
  LOYALTY_THONG_BAO_KHONG_DOI_QUA: "You are not eligible to exchange gifts.",
  LOYALTY_THONG_BAO_TRANG_THAI_01:
    "The gift redemption program for loyal customers only applies to customers who own credit cards at PVcomBank, please register to open a card or contact the nearest PVcomBank branch / transaction office or contact { hot_line} for support. Wish you have a good experience when using SPDV of PVcomBank.",
  LOYALTY_THONG_TIN_NHAN_QUA: "Gift receiving information",
  LOYALTY_THUONG_HIEU: "Brand",
  LOYALTY_TIM_HIEU_THEM: "Learn more",
  LOYALTY_TIM_KIEM: "Search",
  LOYALTY_TRANG_THAI: "Status",
  LOYALTY_UU_DAI_MOI_NHAT: "Latest offers",
  LOYALTY_PV_ONE: "PV One",
  LOYALTY_DIEM_HIEN_TAI: "Current Score",
  LOYALTY_DIEM_HET_HAN: "Date Expire",

  MAP_TAT_CA: "All",
  MAP_TIM_QUAN_HUYEN: "Search for county/district",
  MAP_TIM_TINH_THANH: "Search for province/city",

  NOTIFY_DANG_NHAP_DE_XEM_THONG_BAO: "Please Sign in to view the Notifications",
  NOTIFY_KHONG_CO_THONG_BAO: "There are no Notifications.",
  NOTIFY_TAT_CA: "All",
  NOTIFY_THONG_BAO: "Notifications",
  NOTIFY_UU_DAI: "Promotions",
  NOTIFY_UU_DAI_DA_BI_XOA: "Promotion has been expired",

  QR_ADDRESS_NOT_CONTAIN_SPECIAL: "The recipient's address cannot contain special characters",
  QR_ADDRESS_NOT_NULL: "The consignee's address cannot be blank",
  QR_ADDRESS_NOT_VIETNAMESE: "The consignee's address cannot contain accented Vietnamese",
  QR_ADDRESS_REQUIRE: "Please enter delivery address",
  QR_BAN_CHUA_CHON_NGUON_THANH_TOAN: "Please select a payment source",
  QR_CHI_TIET_GIAO_DICH: "Transaction details",
  QR_CHON_ANH_QR: "Select QR photo",
  QR_CHON_NGUON_KHAC: "Select other source",
  QR_CHO_PHEP: "Allow",
  QR_CONTENT_LUU_MA_THANH_CONG: "Saved QR code",
  QR_DANG_NHAP_BANG_TAI_KHOAN_KHAC: "Log in with another account",
  QR_DANG_NHAP_DE_THANH_TOAN: "Log in to pay",
  QR_DANH_SACH_QUAN_HUYEN: "List of country/ district",
  QR_DANH_SACH_THE: "Card list",
  QR_DANH_SACH_TINH_THANH: "List of province/ city",
  QR_DIA_CHI: "Address",
  QR_DIA_CHI_GIAO_HANG: "Delivery address",
  QR_DIA_CHI_NHAN_HANG: "Received address",
  QR_DICH_VU: "Services",
  QR_DIEM_BAN: "Point of sale",
  QR_DISTRICT_REQUIRE: "Please enter Select county/district",
  QR_DON_GIA: "Price",
  QR_EMAIL: "Email",
  QR_EMAIL_ERROR: "Email is not valid. Please check again",
  QR_EMAIL_NOT_NULL: "Email cannot be blank",
  QR_EMAIL_REQUIRE: "Please enter email",
  QR_GHI_CHU: "Note",
  QR_GIAO_DICH_KHAC: "Other transactions",
  QR_HO_TEN: "Full name",
  QR_HUY: "Cancel",
  QR_KHONG_DECODE_DC_MA_QR: "Invalid QR code. Please try again.",
  QR_KHONG_HOP_LE: "QR code is invalid. Please check again.",
  QR_KY_CUOC: "Billing period",
  QR_LABLE_HUONG_DAN_NHAP_DIA_CHI: "Please enter delivery address",
  QR_LABLE_TAI_KHOAN_THANH_TOAN: "Payment account",
  QR_LABLE_THE_GHI_NO: "Debit card",
  QR_LABLE_THE_TIN_DUNG: "Credit card",
  QR_LABLE_THE_TRA_TRUOC: "Prepaid card",
  QR_LICH_SU_GIAO_DICH: "Transaction history",
  QR_LUU_DIA_CHI: "Saved",
  QR_LUU_MA: "Save QR code",
  QR_MA_DIEM_BAN: "Point of sale ID",
  QR_MA_GIAM_GIA: "Discount code",
  QR_MA_HOA_DON: "Billing number",
  QR_MA_KHACH_HANG: "Customer code",
  QR_MA_SAN_PHAM: "Product code",
  QR_NAME_ADDRESS_NOT_CONTAIN_SPECIAL: "The consignee's name cannot contain special characters",
  QR_NAME_ADDRESS_NOT_NULL: "The consignee's name cannot be blank",
  QR_NAME_ADDRESS_NOT_VIETNAMESE: "The consignee's name must not contain accented Vietnamese",
  QR_NAME_ADDRESS_REQUIRE: "Please enter full name of the consignee",
  QR_NGUON_THANH_TOAN: "Payment source",
  QR_NGUON_THANH_TOAN_KHAC: "Payment source",
  QR_NHA_CUNG_CAP: "Provider",
  QR_NOI_DUNG_HUONG_DAN: "Move camera to QR code image",
  QR_NOI_DUNG_POPUP_HUY_GIAO_DICH: "Do you want to cancel this transaction?",
  QR_NOI_DUNG_POPUP_XIN_QUYEN: "Allow PV-Mobile Banking to access the camera on your device?",
  QR_NOI_DUNG_POPUP_XOA_DIA_CHI: "Do you want to delete this address?",
  QR_OPEN_SETTING: "Setting",
  QR_PASSWORD_KHONG_DUOC_DE_TRONG: "Please enter password",
  QR_PHONE_ERROR: "Please check phone number again",
  QR_PHONE_NOT_NULL: "Phone number cannot be blank",
  QR_PHONE_REQUIRE: "Please enter phone number",
  QR_PROVINCE_REQUIRE: "Please enter select province/city",
  QR_QUAN_HUYEN: "County/ District",
  QR_QUET_THEM_MA: "Scan more code",
  QR_QUY_KHACH_CHUA_CO_THE_GHI_NO: "You do not have any debit card",
  QR_QUY_KHACH_CHUA_CO_THE_TIN_DUNG: "You do not have any credit card",
  QR_QUY_KHACH_CHUA_CO_THE_TRA_TRUOC: "You do not have any prepaid card",
  QR_QUY_KHACH_VUI_LONG_CHON_DIA_CHI: "Please select shipping address or enter a new address",
  QR_QUY_KHACH_VUI_LONG_NHAP_SO_TIEN: "Please enter payment amount",
  QR_SO_DIEN_THOAI: "Phone number",
  QR_SO_DU: "Balance",
  QR_SO_HOA_DON: "Billing number",
  QR_SO_LUONG: "Number",
  QR_SO_TIEN: "Amount",
  QR_SO_TIEN_THANH_TOAN: "Amount",
  QR_TAI_KHOAN: "Account",
  QR_TAI_KHOAN_NGUON: "Source account",
  QR_TAI_KHOAN_THANH_TOAN: "Select payment account",
  QR_TAI_KHOAN_THANH_TOAN_LABLE: "Payment account",
  QR_TAI_KHOAN_THE_KHONG_DU_SO_DU: "Card balance is not enough to make transaction.",
  QR_TAI_KHONG_DUOC_THUC_HIEN_GIAO_DICH: "The source account is inactive. Please contact your nearest branch to support",
  QR_TAO_DIA_CHI_GIAO_HANG: "Delivery address",
  QR_TEN_KHACH_HANG: "Customer name",
  QR_TEN_SAN_PHAM: "Product name",
  QR_THANH_TOAN_CHO: "Payment for",
  QR_THANH_TOAN_QR: "Scan QR code",
  QR_THE_BI_KHOA: "Your card is locked. Please contact the nearest branch or call 1900555592 to support.",
  QR_THE_CHUA_KICH_HOAT: "Your card has not been activated.",
  QR_THE_CHUA_KICH_HOAT_GIAO_DICH_TRUC_TUYEN: "Your card has not been activated online transaction.",
  QR_THE_GHI_NO: "Select debit card",
  QR_THE_THANH_TOAN: "Payment card ",
  QR_THE_TIN_DUNG: "Select credit card",
  QR_THE_TRA_TRUOC: "Select prepaid card",
  QR_THE_TRA_TRUOC_DINH_DANH: "Select prepaid identification card",
  QR_THOI_HAN_THANH_TOAN: "Payment period",
  QR_THONG_BAO: "Notification",
  QR_THONG_BAO_DANG_THUC_HIEN_QUET_THEM_MA_SAN_PHAM:
    "This product QR format is not the same as the previously scanned product QR format. Please check again.",
  QR_THONG_TIN_THANH_TOAN: "Payment info",
  QR_THONG_TIN_THANH_TOAN_QR: "QR payment",
  QR_TINH_THANH_PHO: "Province/City",
  QR_TU_CHOI: "Deny",
  QR_USER_NAME_KHONG_DUOC_DE_TRONG: "Please enter user name",
  QR_XAC_NHAN: "Verify transaction",
  QR_CHU_TAI_KHOAN: "Account owner name",
  QR_TAO_MA_QR_KHAC: "Creat other QR",
  QR_TAI_QR: "Save",

  SALE_BO_LOC: "Filter",
  SALE_CHI_TIET: "Details",
  SALE_DANH_GIA: "Review",
  SALE_HUY: "Cancel",
  SALE_KHONG_CO_DU_LIEU: "There is no program promotions",
  SALE_KHONG_CO_DU_LIEU_FILTER: "No promotion found with filter conditions",
  SALE_LINH_VUC: "Field",
  SALE_PHAN_LOAI_TIN: "Classification of news",
  SALE_TAT_CA: "All",
  SALE_UU_DAI: "Promotions",
  SALE_XONG: "Done",

  SAVING_CHI_TIET_SO_TIET_KIEM: "Detail Passbook",
  SAVING_CHI_NHANH_QUAN_LY_SO: "Branch",
  SAVING_CHON_CHI_NHANH_QUAN_LY_SO: "Select a branch",
  SAVING_CHON_HINH_THUC_DAO_HAN: "Select maturity",
  SAVING_CHON_KY_HAN: "Select term",
  SAVING_CHON_SAN_PHAM: "Select product",
  SAVING_CHON_SO_TIET_KIEM: "Select term deposits",
  SAVING_CHUYEN_VAO_TAI_KHOAN: "Transfer to account",
  SAVING_DANH_SACH_SO_TIET_KIEM: "List of deposit",
  SAVING_DIEN_THOAI: "Phone",
  SAVING_DUOC_NOP_THEM_TIEN_VAO_SO: "Available deposits",
  SAVING_DUOC_RUT_TUNG_PHAN_TRUOC_HAN: "Allowed to withdraw a part",
  SAVING_HINH_THUC_DAO_HAN: "Form maturity",
  SAVING_HINH_THUC_NOP: "Form deposit",
  SAVING_KHONG_CO_SAN_PHAM: "No product",
  SAVING_KHONG_CO_SO_TIET_KIEM: "You do not have any saving account",
  SAVING_KHONG_CO_SO_TIET_KIEM_NOP_THEM: "You do not have any TICH LUY saving account",
  SAVING_KHONG_CO_SO_TIET_KIEM_TAT_TOAN: "You do not have any saving account statement",
  SAVING_KHONG_DUOC_NOP_THEM_TIEN_VAO_SO: "Do not allow to pay more into savings",
  SAVING_KHONG_DUOC_RUT_TUNG_PHAN_TRUOC_HAN: "Do not partially withdraw before the due date",
  SAVING_KY_HAN: "Term",
  SAVING_KY_HAN_NOP_SO_TIEN_NOP: "Deposit term",
  SAVING_LAI_DA_NHAN: "Received interest",
  SAVING_LAI_DUOC_NHAN: "Interest received",
  SAVING_LAI_NHAN_DUOC: "Interest amount",
  SAVING_LAI_SUAT: "Interest",
  SAVING_LAI_SUAT_NOP_GAN_NHAT: "Last deposit interest",
  SAVING_LAI_SUAT_SO_TIEN_NOP: "Interest amount paid",
  SAVING_LAI_THUC_NHAN: "Real interest received",
  SAVING_LAI_XUAT_VIET_THUONG: "Interest",
  SAVING_LOI_CHUA_CHON_CHI_NHANH_QUAN_LY_SO: "You did not select branch",
  SAVING_LOI_CHUA_CHON_HINH_THUC_DAO_HAN: "You did not select form maturity",
  SAVING_LOI_CHUA_CHON_KY_HAN: "You did not select interest term",
  SAVING_LOI_CHUA_CHON_SAN_PHAM: "You did not select product",
  SAVING_LOI_CHUA_NHAP_SO_TIEN: "Please enter amount",
  SAVING_LOI_KY_TU_DAC_BIET: "Promotion code cannot contain special characters",
  SAVING_MO_SO: "Create deposit",
  SAVING_MO_SO_TIET_KIEM: "Create deposit",
  SAVING_NGAY_DAO_HAN: "Release date",
  SAVING_NGAY_DEN_HAN: "Due date",
  SAVING_NGAY_GIAO_DICH: "Transaction date",
  SAVING_NGAY_MO_SO: "Deposit open date",
  SAVING_NGAY_NHAN_LAI: "Interest receipt date",
  SAVING_NGAY_NOP_GAN_NHAT: "Nearest submission date",
  SAVING_NHAP_SO_TIEN: "Enter amount",
  SAVING_NOP_THEM: "Submit Deposit",
  SAVING_NOTE_ADVICE:
    "The interest rate for products is the interest rate when opening the passbook on Mobile Banking, applied to ordinary customers",
  SAVING_QUY_KHACH_MUON_HUY_GIAO_DICH: "Do want to cancel this transaction?",
  SAVING_SAN_PHAM: "Products",
  SAVING_SO_DU_SO: "Saving balance",
  SAVING_SO_DU_SO_SAU_NOP_THEM: "Saving balance after topup",
  SAVING_SO_DU_HIEN_TAI: "Saving current balance",
  SAVING_SO_SO: "Term deposits",
  SAVING_SO_TAI_KHOAN: "Account number",
  SAVING_SO_TIEN: "Amount",
  SAVING_SO_TIEN_GIAO_DICH_TOI_THIEU: "Minimum transfer amount is",
  SAVING_SO_TIEN_GUI: "Deposit amount",
  SAVING_SO_TIEN_GUI_KDV: "Deposit amount",
  SAVING_SO_TIEN_NOP: "Submit amount",
  SAVING_SO_TIEN_NOP_THEM: "Additional submit amount",
  SAVING_SO_TIEN_RUT: "Withdrawal amount",
  SAVING_SO_TIEN_TOI_THIEU: "Min amount:",
  SAVING_SO_TIET_KIEM: "Term deposits",
  SAVING_SO_TIET_ONLINE: "Term deposits online",
  SAVING_SO_TIET_TAI_QUAY: "Term deposits at the counter",
  SAVING_TAI_KHOAN: "Account",
  SAVING_TAI_KHOAN_GHI_CO: "Credit account",
  SAVING_TAI_KHOAN_GHI_NO: "Debit account",
  SAVING_TAI_KHOAN_TRICH_NO: "Debit account",
  SAVING_TAI_KHOAN_NGUON: "Source account",
  SAVING_TAI_KHOAN_THANH_TOAN: "Payment account",
  SAVING_TAT_TOAN: "Final settlement",
  SAVING_TEN_TAI_KHOAN: "Account name",
  SAVING_THAY_DOI_MAT_KHAU: "Change password",
  SAVING_THONG_BAO_NGAY_BAT_DAU_TRUOC_NGAY_KET_THUC: "End date must be after begin date",
  SAVING_THONG_BAO_TRANG_THAI_TAI_KHOAN_NGUON: "The source account is inactive state. Please contact the nearest branch to support.",
  SAVING_THONG_TIN_GIAO_DICH: "Transaction information",
  SAVING_THONG_TIN_SO_TIET_KIEM: "Deposit account details",
  SAVING_TONG_GHI_CO: "Credit total",
  SAVING_TRUY_VAN: "Query",
  SAVING_TU_VAN_GUI_TIET_KIEM: "Deposit advice",
  SAVING_PROMO_CODE: "Promotion code",
  SAVING_YOUR_PROMOTION_CODE: "Your promotion code",
  SAVING_INFO_NOT_MATCH_PROMO: "Saving info does not match with promotion code. Would you like to used correct info?",
  SAVING_DAC_DIEM: "Type",
  SAVING_TAT_TOAN_STK_THANH_CONG: "Passbook has been final settlement complete",
  SAVING_TEN_NGUOI_THU_HUONG: "Name of beneficiary",
  SAVING_VUI_LONG_CHON_SO_TIET_KIEM: "Please choose a passbook",
  SAVING_VUI_LONG_CHON_TAI_KHOAN_NHAN: "Please select account credit",
  SAVING_THOI_GIAN_GHI_NHAN_MO_SO: "Time to record open books",
  SAVING_THONG_BAO_GHI_NHAN_MO_SO:
    "It is currently the time to lock the system to record PVComBank data so this savings book will be recorded on the day {day}",
  SAVING_PROMOTION_CONTENT:
    "Chúc mừng Quý khách đủ điều kiện tham gia CTKM {event_name} và có cơ hội nhận tới 10.000.000 điểm PVOne. Tham gia ngay?",
  SAVING_PROMOTION_SUB_CONTENT:
    "(Bằng việc đồng ý tham gia CTKM, Quý khách đồng thời đồng ý để PVcomBank phong tỏa Thẻ tiết kiệm này trong vòng 01 tháng kể từ ngày mở).",
  SAVING_PROMOTION_EVENT_NAME: "Mở tiềm năng chinh phục ước mơ",
  SAVING_PROMOTION_EVENT_MORE_INFO: "Detail information can be found ",
  SAVING_PROMOTION_EVENT_HERE: "here",
  SAVING_PROMOTION_APPLY_SUCCESS_AMOUNT:
    "PVcomBank congratulates you on receiving a special gift into your payment account worth VND {amount}.",
  SAVING_PROMOTION_APPLY_SUCCESS: `Chúc mừng Quý khách đã nhận được lượt tham gia nhận quà từ CTKM “Mở tiềm năng – Mở tương lai”. \n Truy cập và tham gia ngay trên ứng dụng PV Mobile Banking!`,

  SAVING_PROPMOTION_FINALIZATION_MESSAGE:
    "Your savings account is participating in the program {event_name}, \nwhen pre-payment PVcomBank will recover the value of the gift you have received from the program.",
  SAVING_PROMOTION_ACTION_AGREE: "Agree",
  SAVING_PROMOTION_ACTION_NOT_AGREE: "Close",
  SAVING_NOTE_CUT_OFF_TIME_OPEN:
    "Notice: The interest of new deposit transactions completed at the cutoff time will be calculated the next day according to PVcomBank's Terms and Conditions.",
  SAVING_NOTE_CUT_OFF_TIME_TOPUP:
    "Notice: The interest of adding deposit transactions completed at the cutoff time will be calculated the next day according to PVcomBank's Terms and Conditions.",
  SAVING_NOTE_DIEU_KHOAN_DIEU_KIEN_1: "I have read and agreed to the",
  SAVING_NOTE_DIEU_KHOAN_DIEU_KIEN_2: "General Terms & Conditions",
  SAVING_NOTE_DIEU_KHOAN_DIEU_KIEN_3: "of Savings Deposit of PVcomBank",

  SETTING_BD_MAC_DINH: "Default",
  SETTING_BD_NGUONG_AN_TOAN: "Safety threshold",
  SETTING_BIEU_DO_HIEN_THI: "Display chart ",
  SETTING_CAP_NHAT_NGON_NGU_THANH_CONG: "Update language display successfully",
  SETTING_CAP_NHAT_NGON_NGU_THAT_BAI: "Update display language failed",
  SETTING_CHON_BIEU_DO_HIEN_THI: "Select chart display",
  SETTING_CHON_NGON_NGU: "Select language",
  SETTING_CHUC_NANG_TAM_THOI_BI_KHOA: "This function is temporarily locked",
  SETTING_CHU_THICH_CHO_PHEP_NHAN_THONG_BAO: "You will receive notifications of events and incentives from PVcomBank",
  SETTING_CHU_THICH_KHUON_MAT: "You can login by face ID",
  SETTING_CHU_THICH_NHAN_THONG_BAO: "Enable this feature to receive notifications of events and incentives from PVcomBank",
  SETTING_CHU_THICH_QUEN_MAT_KHAU: "Please come to the nearest branch to recover your password",
  SETTING_CHU_THICH_VAN_TAY: "You can login by fingerprint",
  SETTING_CHU_Y: "Note",
  SETTING_DANG_NHAP_BANG_KHUON_MAT: "Login with faceID",
  SETTING_DANG_NHAP_BANG_VAN_TAY: "Login with fingerprint",
  SETTING_DANG_NHAP_KHUON_MAT_NOTE: "Note: All faces are registered in the device can be verified",
  SETTING_DANG_NHAP_LUC: "Login at",
  SETTING_DANG_NHAP_VAN_TAY_NOTE: "Note: All fingerprints are registered in the device can be verified",
  SETTING_DANH_BA: "Phonebook",
  SETTING_DANH_SACH_DICH_VU: "Services list",
  SETTING_HUONG_DAN_SU_DUNG: "User guide",
  SETTING_KHACH_HANG_THAN_THIET: "Loyalty Customer",
  SETTING_LOI_CHUA_NHAP_MAT_KHAU_HIEN_TAI: "Please enter your current password",
  SETTING_LOI_CHUA_NHAP_MAT_KHAU_MOI: "Please enter a new password",
  SETTING_LOI_CHUA_NHAP_LAI_MAT_KHAU_MOI: "Please re-enter your new password",
  SETTING_MAT_KHAU: "Password",
  SETTING_NHAN_THONG_BAO: "Get notifications",
  SETTING_THAY_DOI_MAT_KHAU: "Change password",
  SETTING_NHAP_MAT_KHAU_HIEN_TAI: "Enter current password",
  SETTING_NHAP_MAT_KHAU_MOI: "Enter new password",
  SETTING_NHAP_LAI_MAT_KHAU_MOI: "Re-enter new password",
  SETTING_LOI_MAT_KHAU_BI_TRUNG: "New password isn't match the current username or current password",
  SETTING_LOI_MAT_KHAU_KHONG_HOP_LE: "Invalid password",
  SETTING_LOI_NHAP_SAI_MAT_KHAU: "Current password is incorrect",
  SETTING_LOI_NHAP_SAI_MAT_KHAU_CONFIRM: "New password does not match",
  SETTING_NOTE_DOI_MAT_KHAU: "Note: A valid password must meet the following criteria:",
  SETTING_RULES_CHANGE_PASS_1: "- Minimum length 06 characters",
  SETTING_RULES_CHANGE_PASS_2: "- Includes letters and numbers, uppercase and lowercase letters or special characters",
  SETTING_RULES_CHANGE_PASS_3: "- Must not be the same as the login name",
  SETTING_RULES_CHANGE_PASS_4: "- Must not be the same as the old password",
  SETTING_THAY_DOI_MAT_KHAU_THANH_CONG: "Password change successful. Please log in again.",
  SETTING_NOTE_DOI_MAT_KHAU_FORCE_CHANGE: "To ensure secure transactions, please update your password to continue using the service.",
  SETTING_NOTE_DOI_MAT_KHAU_HET_HAN:
    "Your PV-Mobile Banking login password has expired. Please change your password to continue using the service.",
  SETTING_NOTE_DOI_MAT_KHAU_LAN_DAU: "Please change the password for the first login",
  SETTING_THONG_BAO_BAT_MO_KHOA_BANG_KHUON_MAT: "Device has not installed face  verification. Please check again.",
  SETTING_THONG_BAO_BAT_MO_KHOA_BANG_VAN_TAY: "Device has not installed fingerprint verification. Please check again.",
  SETTING_THONG_BAO_CAI_DAT_XAC_THUC_KHUON_MAT: "Please login application. select utilities to enable face ID sign in.",
  SETTING_THONG_BAO_CAI_DAT_XAC_THUC_VAN_TAY: "Please login application. select utilities to enable fingerprint login feature.",
  SETTING_THONG_BAO_DONG_XAC_THUC_KHUON_MAT: "Face ID login feature has been turned off.",
  SETTING_THONG_BAO_DONG_XAC_THUC_VAN_TAY: "Fingerprint login feature is turned off.",
  SETTING_THONG_BAO_HOI_OFF_ACCOUNT_BLANCE: "Would you like to disable account balance viewing?",
  SETTING_THONG_BAO_HOI_ON_ACCOUNT_BLANCE: "Would you like to enable account balance viewing?",
  SETTING_THONG_BAO_KHOA_KHUON_MAT:
    "You have entered the wrong face ID too many times. Please go to the device's face ID settings to reactivate this feature.",
  SETTING_THONG_BAO_KHOA_VAN_TAY:
    "You have entered the wrong fingerprint too many times. Please go to the device's fingerprint settings to reactivate this feature.",
  SETTING_THONG_BAO_MO_XAC_THUC_KHUON_MAT: "Face ID login verification has been enabled.",
  SETTING_THONG_BAO_MO_XAC_THUC_VAN_TAY: "Fingerprint login verification has been enabled.",
  SETTING_THONG_BAO_OFF_ACCOUNT_BLANCE: "Off view account balance {account} successfully",
  SETTING_THONG_BAO_OFF_NOTIFY: "Receive notification funtion is turned off",
  SETTING_THONG_BAO_ON_ACCOUNT_BLANCE: "Register to view your account balance {account} successfully",
  SETTING_THONG_BAO_ON_NOTIFY: "Receive notification funtion is turned on",
  SETTING_THONG_BAO_QUET_VAN_TAY_DANG_NHAP: "Please scan the fingerprint to login the application.",
  SETTING_THONG_BAO_QUET_VAN_TAY_TREN_THIET_BI: "Please scan the registered fingerprint on the device.",
  SETTING_THONG_BAO_TAM_KHOA_VAN_TAY: "You have entered the wrong fingerprint many times. Please try again in 30 seconds.",
  SETTING_TIEN_ICH: "Utilities",
  SETTING_CAI_DAT: "Settings",
  SETTING_VAN_TAY: "Fingersprint",
  SETTING_XAC_THUC_KHUON_MAT: "Face ID verification",
  SETTING_XAC_THUC_LOI: "Failed",
  SETTING_XAC_THUC_LOI_THU_LAI: "The verification is not correct. Please try again.",
  SETTING_XAC_THUC_VAN_TAY: "Fingerprint verification",
  SETTING_XEM_SO_DU: "View balance ",
  SETTING_QL_DS_THU_HUONG: "Manage beneficiary list",
  SETTING_DOI_MAT_KHAU_DANG_NHAP: "Change login password",
  SETTING_PHUONG_THUC_XAC_THUC: "Authentication method settings",
  SETTING_TINH_NANG_YEU_THICH: "Favorite feature settings",
  SETTING_TK_MAC_DINH: "Default account settings",
  SETTING_GOI_HAN_MUC: "Change the transaction limit package",
  SETTING_THONG_BAO: "Notification settings",
  SETTING_THONG_TIN_NGUOI_DUNG: "User information settings",
  SETTING_LAY_MA_XAC_THUC: "Get authentication code",
  SETTING_CAI_DAT_CHU_DE: "Setting theme",
  SETTING_CHU_DE_MAC_DINH: "Default",
  SETTING_CHU_DE_NAM_MOI: "New Year",
  SETTING_PV_ONLINE_BANKING: "PV Online Banking",
  SETTING_CAU_HOI_THUONG_GAP: "Frequently Asked Questions",

  SMS_BANK_DANG_KY: "Register",
  SMS_BANK_DANG_KY_NGAY: "Register now",
  SMS_BANK_DANG_KY_SMS_BANKING: "SMS Banking register",
  SMS_BANK_DICH_VU: "Services",
  SMS_BANK_DICH_VU_TAI_CHINH: "Financial services",
  SMS_BANK_DV_TAI_CHINH_NOTE:
    "Financial services allow the use of registered phone numbers to make phone deposits, activate PV-eCommerce services, balance inquiry and account transactions via SMS",
  SMS_BANK_HUY: "Cancel",
  SMS_BANK_HUY_DV: "Cancel service",
  SMS_BANK_LUU: "Save",
  SMS_BANK_NOTE_CHUA_DANG_KY_SMS: "You have not registered SMS banking.",
  SMS_BANK_SMS_BIEN_DONG_SO_DU: "Balance fluctuation message",
  SMS_BANK_SMS_BIEN_DONG_SO_DU_NOTE: "Receive a message of fluctuations in balance of payment accounts",
  SMS_BANK_SMS_KHAC: "Other message",
  SMS_BANK_SO_DIEN_THOAI: "Phone number",
  SMS_BANK_THEM_SO: "Add phone number",
  SMS_BANK_THOAT: "Exit",
  SMS_BANK_THONG_BAO_CHUA_NHAP_SDT: "Please enter phone number.",
  SMS_BANK_THONG_BAO_DK_IT_NHAT: "Please register to receive balance fluctuations of at least 1 payment account.",
  SMS_BANK_THONG_BAO_KHONG_DUOC_DANG_KY_DO_SDT_DA_DK_DV:
    "Financial services are not registered because of the phone number registered for financial services for others.",
  SMS_BANK_THONG_BAO_SDT_DA_DUOC_DK_NGUOI_DUNG_KHAC:
    "Phone number has registered financial services for other users. Please use other phone number.",
  SMS_BANK_THONG_BAO_SDT_KHONG_TON_TAI: "Phone number does not exist.",
  SMS_BANK_THONG_BAO_TU_NGAN_HANG: "Notice from the bank",
  SMS_BANK_TIEN_GUI: "Deposits",
  SMS_BANK_TIEN_ICH: "Utilities",
  SMS_BANK_TIEN_VAY: "Loan",
  SMS_BANK_TK_THANH_TOAN: "Payment account",
  SMS_BANK_TK_TRICH_NO: "Debit account",
  SMS_QUY_KHACH_MUON_HUY_GIAO_DICH: "Do you want to cancel this transaction?",

  SM_OTP_BUOC_1: "1. Confirm registration",
  SM_OTP_BUOC_2: "2. Create a security PIN. Complete registration",
  SM_OTP_CAI_DAT_FACE_ID: "Face transaction authentication",
  SM_OTP_CAI_DAT_VAN_TAY: "Authenticate transaction by fingerprint",
  SM_OTP_CHUA_NHAP_MA_GIAO_DICH: "You have not entered the transaction code yet",
  SM_OTP_CHUA_NHAP_MA_KICH_HOAT: "Please enter the activation code",
  SM_OTP_CHUA_NHAP_PASS_DANG_NHAP: "Please enter the password",
  SM_OTP_CHUA_NHAP_PIN: "Please enter PIN code",
  SM_OTP_CHUA_NHAP_PIN_CONFIRM: "Please enter new PIN again",
  SM_OTP_CHUA_NHAP_PIN_NEW: "Please enter new PIN",
  SM_OTP_CHUA_NHAP_PIN_OLD: "Please enter your current PIN",
  SM_OTP_CHUA_NHAP_USER: "Please enter your username",
  SM_OTP_DANG_KY_SM_OTP: "Smart OTP  register",
  SM_OTP_DANG_KY_NGAY: "Register",
  SM_OTP_DOI_MA_PIN: "Change PIN",
  SM_OTP_DOI_MA_PIN_SMART: "Change Smart OTP PIN",
  SM_OTP_ERROR_CONFIRM_PIN_MOI: "The new PIN was entered incorrectly. Please check again",
  SM_OTP_ERROR_MA_KICH_HOAT: "The activation code is not valid. Please check it again",
  SM_OTP_ERROR_NHAP_LAI_MA_PIN: "PIN does not match. Please check again",
  SM_OTP_ERROR_NHAP_MA_PIN: "The PIN is invalid. Please check it again",
  SM_OTP_ERROR_PIN: "PIN code is incorrect. Please check again.",
  SM_OTP_ERROR_PIN_MOI: "The new PIN must not match the old PIN",
  SM_OTP_ERROR_PIN_MOI_KHONG_HOP_LE: "The PIN is invalid. Please check it again",
  SM_OTP_GIOI_THIEU_SM_OTP: "Introduce Smart OTP",
  SM_OTP_HET_SO_LAN_NHAP_MA_PIN:
    "Your authentication method is temporarily locked for 30 minutes, due to incorrect PIN entering the number of times allowed",
  SM_OTP_HOAC_NHAP_MA_GIAO_DICH: "Or enter transaction code",
  SM_OTP_HOAC_NHAP_MA_GIAO_DICH_KICH_HOAT: "Or enter the activation code",
  SM_OTP_HOAC_QUET_QR: "Or scan QR",
  SM_OTP_HOAC_QUET_QR_KICH_HOAT: "Or scan QR code to activate",
  SM_OTP_KHONG_THE_DANG_KY_DO_1: "You have already registered for Smart OTP on other devices.",
  SM_OTP_KHONG_THE_DANG_KY_DO_2: "Another quarter has deleted the PVCombank application or has reinstalled the device.",
  SM_OTP_KICH_HOAT: "Activate",
  SM_OTP_KICH_HOAT_SM_OTP: "Smart OTP Activated",
  SM_OTP_LAY_LAI_MA_KICH_HOAT: "Redeem activation code",
  SM_OTP_LAY_MA_OTP: "Get the OTP verification code",
  SM_OTP_LOAI_GIAO_DICH: "Transaction type",
  SM_OTP_LOI_MA_KICH_HOAT_3_LAN:
    "The activation code has been canceled because you have entered it incorrectly more than 03 times. In case of forgetting the activation code, please perform the new activation code again.",
  SM_OTP_LOI_NHAP_USER: "Incorrect username",
  SM_OTP_LOI_PASS_DANG_NHAP: "Incorrect password",
  SM_OTP_MAT_THIET_BI_HOAC_KICH_HOAT_LAI_SM_OTP: "Device Lost / Reactivate",
  SM_OTP_MA_GIAO_DICH: "Transaction code",
  SM_OTP_MA_GIAO_DICH_KHONG_HOP_LE: "Invalid OTP code. Please try again.",
  SM_OTP_MA_KICH_HOAT: "Activation code",
  SM_OTP_MA_OTP: "OTP code",
  SM_OTP_MA_QR_KHONG_HOP_LE: "Invalid QR code",
  SM_OTP_NHAP_LAI_MA_PIN: "Confirm PIN",
  SM_OTP_NHAP_LAI_PIN_MOI: "Enter new PIN again",
  SM_OTP_NHAP_MA: "Enter the code",
  SM_OTP_NHAP_MA_GIAO_DICH: "Enter transaction code",
  SM_OTP_NHAP_MA_HIEN_THI_XAC_THUC_GIAO_DICH: "Enter transaction code displayed on the transaction  verification screen",
  SM_OTP_NHAP_MA_PIN: "Enter PIN code",
  SM_OTP_NHAP_MA_PIN_SAI: "The PIN is incorrect. You have {counter} attempts remaining",
  SM_OTP_NHAP_PIN_HIEN_TAI: "Enter current PIN",
  SM_OTP_NHAP_PIN_MOI: "Enter new PIN",
  SM_OTP_NHAP_PIN_SAI_CON_1_LAN:
    "You entered your PIN incorrectly 04 times. If you enter it incorrectly next time, your authentication method will be temporarily locked for 30 minutes.",
  SM_OTP_NOI_DUNG_GIOI_THIEU_SM_OTP:
    "Smart OTP is an advanced security method, helping to improve the security in online transactions. Register Smart OTP in 2 easy steps",
  SM_OTP_NOTE_CHECK_AUTH_1: "I agree with",
  SM_OTP_NOTE_CHECK_AUTH_2: "Terms and conditions",
  SM_OTP_NOTE_CHECK_AUTH_3: "using Smart OTP",
  SM_OTP_NOTE_CHECK_CHUYEN_THIET_BI: "I agree to change Smart OTP registration device.",
  SM_OTP_NOTE_CHECK_CHU_SO_HUU_DUY_NHAT_1: "I am",
  SM_OTP_NOTE_CHECK_CHU_SO_HUU_DUY_NHAT_2: "UNIQUE OWNER",
  SM_OTP_NOTE_CHECK_CHU_SO_HUU_DUY_NHAT_3: "of the new device.",
  SM_OTP_NOTE_CHUYEN_THIET_BI: "Confirm Smart OTP change to new device",
  SM_OTP_NOTE_ERROR_NHAP_MA: "The activation code is not valid. Please check it again",
  SM_OTP_NOTE_KICH_HOAT: "Activate Smart OTP for new customers or customers who require Smart OTP installation on Internet Banking",
  SM_OTP_NOTE_NHAP_LAI_MA_PIN: "Confirm Smart OTP protection PIN",
  SM_OTP_NOTE_NHAP_MA: "Smart OTP activation code is sent via SMS to phone number {number}. The validity period is within 24 hours.",
  SM_OTP_NOTE_NHAP_PHIEN_XAC_THUC_GIAO_DICH:
    "Use PV MobileBanking with Smart OTP installed to scan QR code or enter transaction code below to get OTP authentication code",
  SM_OTP_NOTE_TAO_MA_PIN: "Create Smart OTP protection PIN",
  SM_OTP_NOTE_TAO_MA_PIN_TRUNG_LIEN_TUC:
    "You should not set a PIN consisting of consecutive or identical numbers. For example: 123456, 111111 ...",
  SM_OTP_NOTE_THEM_TOUCH: "Note: All fingerprints registered in the device can be authenticated",
  SM_OTP_PASS_DANG_NHAP: "Password",
  SM_OTP_PHIEN_GIAO_DICH: "Session",
  SM_OTP_QUEN_MA_PIN: "PIN recovery",
  SM_OTP_QUEN_PIN_COUNT_DOWN: "Your PIN is locked. The lock will be unlocked later",
  SM_OTP_QUET_QR_XAC_THUC_GIAO_DICH: "Scan QR code displayed on the transaction  verification screen",
  SM_OTP_QUY_KHACH_MUON_HUY_GIAO_DICH: "Do you want to Cancel this transaction?",
  SM_OTP_SETTING_SM_OTP: "Smart OTP setting",
  SM_OTP_SO_TIEN: "Amount",
  SM_OTP_TAO_MA_PIN: "Create a PIN",
  SM_OTP_TERM:
    "<p style='text-align: justify;background: transparent;margin-top: 0.04in;margin-bottom: 0.04in;line-height: 130%;'><strong>Điều 1. Phạm vi áp dụng</strong></p>\r\n\r\n\r\n<p style='text-align: justify;background: transparent;text-indent: 0.2in;margin-top: 0.04in;margin-bottom: 0.04in;line-height: 130%;'>Điều khoản và điều kiện áp dụng đối với khách hàng cá nhân và doanh nghiệp sử dụng các dịch vụ Ngân hàng điện tử của PVcomBank và xác thực giao dịch bằng phương thức Smart OTP.</p>\r\n\r\n\r\n<p style='text-align: justify;background: transparent;margin-top: 0.04in;margin-bottom: 0.04in;line-height: 130%;'><strong>Điều 2. Giải thích từ ngữ</strong></p>\r\n\r\n\r\n<ol>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Ngân hàng: Là Ngân hàng Thương mại cổ phần Đại Chúng Việt Nam, gọi tắt là PVcomBank.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>PVcomBank Smart OTP: Là ứng dụng được phát triển bởi PVcomBank, cài đặt trên điện thoại di động của khách hàng và được sử dụng để xác thực giao dịch trên các kênh Ngân hàng điện tử của PVcomBank.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>OTP (One Time Password): Là mật khẩu sử dụng một lần, do hệ thống Smart OTP sinh ra, sử dụng để xác thực giao dịch trực tuyến của khách hàng. OTP được ứng dụng PVcomBank Smart OTP sinh ra ngẫu nhiên khi phát sinh giao dịch, có hiệu lực trong khoảng thời gian xác định theo quy định của Ngân hàng trong từng thời kỳ.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>PIN: Là mã số do khách hàng cài đặt, được sử dụng để xác nhận quyền truy cập, sử dụng, thay đổi và tạo mã xác thực trong ứng dụng Smart OTP.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Thời gian xử lý giao dịch: thời gian xử lý các giao dịch điện tử do Khách hàng chủ động gửi yêu cầu:</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Khách hàng được thực hiện giao dịch 24 giờ trong ngày và 07 ngày trong tuần.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>PvcomBank sẽ gửi thông báo ngay cho Khách hàng ngay khi có yêu cầu từ phía khách hàng. Trên thông báo giao dịch cuối kỳ, đối với những giao dịch nhận được sau thời gian chạy xử lý cuối ngày sẽ được hệ thống PvcomBank coi là giao dịch của ngày tiếp theo.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Đối với các giao dịch trả lãi tự động, thu nợ tự động… PvcomBank sẽ gửi thông báo biến động tài khoản vào sáng của ngày kế tiếp.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n</ol>\r\n\r\n\r\n<p style='margin-bottom: 0.04in; line-height: 100%; text-align: justify; background: transparent; margin-top: 0.04in;'><strong>Điều 3. Quyền của khách hàng</strong></p>\r\n\r\n\r\n<ol>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Cài đặt, đăng ký ứng dụng PVcomBank Smart OTP.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Thiết lập và thay đổi phương thức bảo vệ Smart OTP qua mã PIN, vân tay hoặc nhận diện khuôn mặt.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Chuyển đổi thiết bị cài đặt PVcomBank Smart OTP.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Hủy đăng ký xác thực bằng Smart OTP.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Yêu cầu Ngân hàng cấp lại mã PIN khi quên hoặc xóa ứng dụng Smart OTP khi chưa hủy đăng ký phương thức xác thực này.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n</ol>\r\n\r\n\r\n<p style='margin-bottom: 0.04in; line-height: 100%; text-align: justify; background: transparent; margin-top: 0.04in;'><strong>Điều 4. Trách nhiệm của khách hàng</strong></p>\r\n\r\n\r\n<ol>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Bảo đảm thiết bị cài đặt Smart OTP an toàn. Không được sử dụng các thiết bị đã can thiệp vào quyền quản trị thiết bị (admin) thông qua các biện pháp như jailbreak (trên hệ điều hành iOS) hoặc root (trên hệ điều hành Android); thiết bị cài đặt các ứng dụng bên thứ ba không được phát hành trên các kho ứng dụng chính thống của các hệ điều hành iOS (App Store), Android (Google Play).</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Không tiết lộ phương thức bảo vệ Smart OTP (mã PIN, vân tay, nhận diện khuôn mặt) và mã xác thực OTP cho bất kỳ người nào.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Thông báo ngay cho Ngân hàng thông qua hotline hoặc các chi nhánh, phòng giao dịch khi phát hiện hoặc nghi ngờ các thông tin tên đăng nhập, mật khẩu, phương thức bảo vệ Smart OTP (mã PIN, vân tay, nhận diện khuôn mặt), mã OTP bị lộ.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Chịu trách nhiệm hoàn toàn về việc bảo quản và sử dụng tên đăng nhập, mật khẩu, các thông tin liên quan đến Smart OTP kể từ khi được Ngân hàng cung cấp. Khách hàng phải thông báo ngay cho PVcomBank để kịp thời xử lý khi tên truy cập, mật khẩu hoặc các yếu tố định danh khác bị mất, đánh cắp, bị lội hoặc nghi bị đánh cắp, đồng thời khách hàng phải chịu trách nhiệm về những thiệt hại, tổn thất và rủi ro khác trước khi thông báo cho PVcomBank.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Tuân thủ đúng hướng dẫn về bảo mật được Ngân hàng ban hành, sửa đổi theo từng thời kỳ khi sử dụng các dịch vụ Ngân hàng điện tử của PvcomBank</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Khách hàng thừa nhận rằng bất cứ hành động truy cập nào vào dịch vụ Ngân hàng điện tử bằng tên truy cập với đúng mật khẩu truy cập và/ hoặc các yếu tố định danh khác do Pvcombank cấp cho khách hàng đều được coi là Khách hàng truy cập.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Tin nhắn được coi là đã gửi cho khách hàng nếu việc gửi tin này đã được thực hiện bởi nhà cung cấp dịch vụ bất kể khách hàng có thực sự nhận được tin nhắn hay không.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Khách hàng chịu trách nhiệm áp dụng mọi biện pháp hợp lý nhằm đảm bảo an toàn, thiết bị kết nối, phầm mềm hệ thống truy cập, phần mềm ứng dụng… do khách hàng sử dụng nhằm kiểm soát, phòng ngừa và ngăn chặn việc sử dụng hoặc truy cập trái phép dịch vụ.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n</ol>\r\n\r\n\r\n<p style='margin-bottom: 0.04in; line-height: 100%; text-align: justify; background: transparent; margin-top: 0.04in;'><strong>Điều 5. Quyền của Ngân hàng</strong></p>\r\n\r\n\r\n<ol>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Yêu cầu KH cung cấp thông tin cá nhân khi thực hiện các yêu cầu liên quan đến dịch vụ PVcomBank Smart OTP.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Có quyền ngừng cung cấp hoặc chấm dứt dịch vụ mà không cần có sự đồng ý của khách hàng trong trường hợp vi phạm các quy định tại Điều khoản và điều kiện sử dụng dịch vụ PVcomBank Smart OTP.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Khi khách hàng khiếu nại dịch vụ qua hotline hoặc chi nhánh, phòng giao dịch, Ngân hàng có quyền ghi âm cuộc gọi, lưu trữ thông tin khách hàng để xử lý các vấn đề phát sinh nếu có.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Phí dich vụ được PvcomBank công bố từng thời kỳ.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Khách hàng uỷ quyền cho PVcomBank được quyền tự động trích nợ phí sử dụng dịch vụ trên bất kỳ tài khoản nào mở tại PVcomBank để thanh toán. Phí dịch vụ được thu trước hoặc sau hoặc ngay khi phát sinh giao dịch tuỳ vào từng loại hình dịch vụ PVcomBank cung cấp.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>PvcomBank được quyền thay đổi nội dung các điều kiện, điều khoản này bằng cách gửi thông báo thay đổi cho khách hàng.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n</ol>\r\n\r\n\r\n<p style='margin-bottom: 0.04in; line-height: 100%; text-align: justify; background: transparent; margin-top: 0.04in;'><strong>Điều 6. Trách nhiệm của Ngân hàng</strong></p>\r\n\r\n\r\n<ol>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Cung cấp dịch vụ, đảm bảo an toàn thông tin giao dịch, thông tin xác thực giao dịch của khách hàng.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Hướng dẫn, hỗ trợ khách hàng sử dụng dịch vụ, khiếu nại liên quan nếu có.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>PVcomBank không chịu trách nhiệm đối với những thiệt hại, tổn thất do Khách hàng phát sinh trong quá trình sử dụng dịch vụ, trừ phi những thiệt hại, tổn thất này là do lỗi cố ý của PvcomBank.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>PvcomBank không chịu trách nhiệm đối với những thiệt hại trực tiếp hoặc gián tiếp mà Khách hàng phải chịu phát sinh từ/ hoặc do:</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Việc khách hàng để mất hoặc lộ thông tin truy cập, mật khẩu hoặc các yếu tố định danh khác PvcomBank cung cấp.</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Việc tin nhắn được thực hiện bởi 1 bên thứ ba mà bên thứ ba đã thực hiện việc kết nối thiết bị của họ tới số điện thoại mà Khách hàng đã đăng ký hoặc</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Sự gián đoạn của hệ thống trong quá trình cung cấp dịch vụ do các nguyên nhân ngoài khả năng kiểm soát hợp lý của PvcomBank, bao gồm nhưng không giới hạn như dịch vụ đang nâng cấp, lỗi đường truyền của nhà cung cấp dịch vụ Internet, hệ thống của bên thứ ba tham gia, các gián đoạn bất khả kháng…</p>\r\n\r\n\r\n    </li>\r\n\r\n\r\n    <li>        <p style='margin-bottom: 0.14in; line-height: 115%; text-align: justify; background: transparent;'>Tất cả các chỉ dẫn thanh toán do Khách hàng gửi yêu cầu được coi là không huỷ ngang.</p>\r\n\r\n\r\n</li>\r\n\r\n\r\n</ol>\r\n\r\n\r\n<p style='text-align: justify;background: transparent;text-indent: 0.2in;margin-top: 0.04in;margin-bottom: 0.04in;line-height: 130%;'>Trường hợp cần thêm thông tin về dịch vụ, Quý khách vui lòng liên hệ:</p>\r\n\r\n\r\n<p style='text-align: justify;background: transparent;text-indent: 0.2in;margin-top: 0.04in;margin-bottom: 0.04in;line-height: 130%;'>Trung tâm Chăm sóc khách hàng (PVcomBank Call Center). </p>\r\n\r\n\r\n<p style='text-align: justify;background: transparent;text-indent: 0.2in;margin-top: 0.04in;margin-bottom: 0.04in;line-height: 130%;'>Hotline: 1900555592.</p>\r\n\r\n\r\n<p style='text-align: justify;background: transparent;text-indent: 0.2in;margin-top: 0.04in;margin-bottom: 0.04in;line-height: 130%;'>Hoặc email <a>pvb@pvcombank.com.vn</a>.</p>",
  SM_OTP_THAY_DOI_THIET_BI_SM_OTP: "Change device activate Smart OTP",
  SM_OTP_THEM_FACE_ID: "Face authentication settings",
  SM_OTP_THEM_VAN_TAY: "Fingerprint authentication settings",
  SM_OTP_THONG_BAO_ACC_DA_DK_SMART_TREN_DEVICE_KHAC:
    "You have already registered for Smart OTP on other devices. If you want to register Smart OTP on this device, please log in on the Smart OTP registered device and perform Smart OTP device registration. Or go to the nearest branch for advice.",
  SM_OTP_THONG_BAO_CHUA_CAI_DAT_PIN_SMART: "Please complete activation of Smart OTP",
  SM_OTP_THONG_BAO_CHUYEN_THIET_BI_THANH_CONG:
    "Changing the Smart OTP device registration successfully. From the present time, this device is invalid for transaction verification. {new_line}Please log in to PV-Moblie Banking and activate Smart OTP on the new device to complete.",
  SM_OTP_THONG_BAO_DANG_KY_THANH_CONG_NOTE:
    "You have successfully registered Smart OTP on this device. You absolutely do not provide your Smart OTP username, password, Smart OTP protection code and OTP for other people or websites not of PVcomBank or not affiliated with PVcomBank.",
  SM_OTP_THONG_BAO_DANG_NHAP_KHOI_PHUC_PIN: "Please Login to Recover PIN",
  SM_OTP_THONG_BAO_DA_KICH_HOAT_THIET_BI_KHAC:
    "Tài khoản của Quý khách đã cài đặt trên thiết bị khác hoặc xóa ứng dụng PV- Mobile Banking hoặc đã cài đặt lại điện thoại.",
  SM_OTP_THONG_BAO_DOI_MA_PIN_THANH_CONG:
    "The Smart OTP security PIN has been successfully changed. Please do not provide the PIN to anyone.",
  SM_OTP_THONG_BAO_HOI_CAI_DAT_FACE_ID: "Do you want to install Face ID for Smart OTP?",
  SM_OTP_THONG_BAO_HOI_CAI_DAT_VAN_TAY: "Do you want to install fingerprint for Smart OTP?",
  SM_OTP_THONG_BAO_HOI_DANG_KY_SMART:
    "Smart OTP is recommended by the State Bank of Vietnam as the highest security method for customers. Now, Smart OTP authentication method is available for application. If Smart OTP isn't registered before 31/12/2020, transactions from VND 100 millions/day couldn't be made via Internet Banking and Mobile Banking.",
  SM_OTP_THONG_BAO_HOI_HUY_DANG_KY: "Do you want to Cancel registration Smart OTP?",
  SM_OTP_THONG_BAO_HOI_HUY_KICH_HOAT: "Do you want to Cancel deactivate Smart OTP?",
  SM_OTP_THONG_BAO_HOI_HUY_LAY_MA: "Do want to cancel the OTP code?",
  SM_OTP_THONG_BAO_HUONG_DAN_KICH_HOAT_LAI:
    "<ol>\r\n    <li style='line-height: 1.5;'>Nếu muốn chuyển Smart OTP từ thiết bị cũ sang thiết bị mới, vui lòng thực hiện:<br>Bước 1:&nbsp;Đăng nhập lại ứng dụng PV-Mobile Banking trên thiết bị cũ.<br>Bước 2: Tại LeftMenu chọn&nbsp;<strong>Chuyển đổi thiết bị kích hoạt Smart OTP</strong> -&gt; Đồng ý chuyển đổi.<br>Bước 3:&nbsp;Đăng nhập app PV-Mobile Banking trên thiết bị mới và thực hiện kích hoạt Smart OTP.</li>\r\n    <li style='line-height: 1.5;'>Trường hợp Quý khách đã xóa ứng dụng hoặc không dùng thiết bị cũ, vui lòng thực hiện:<br>Bước 1:&nbsp;Dùng số điện thoại đã đăng ký với ngân hàng thực hiện soạn tin nhắn&nbsp;<span style='color: #ff0000;'>PVB HUY SMARTOTP</span> gửi&nbsp;<span style='color: #ff0000;'>8049</span>/<span style='color: #ff0000;'>6089</span>.<br>Bước 2: Sau khi nhận được tin nhắn thông báo hủy thành công, đăng nhập lại app và thực hiện đăng ký lại.</li>\r\n</ol>",
  SM_OTP_THONG_BAO_KHONG_THE_DANG_KY: "You cannot register Smart OTP on this device because:",
  SM_OTP_THONG_BAO_KICH_HOAT_LAI_THANH_CONG_NOTE:
    "You have successfully activated Smart OTP. To ensure your safety, PVcomBank transfer your limit to 100 million/day. In case you want to increase your limit, please contact 190055552",
  SM_OTP_THONG_BAO_LAY_LAI_PASS_THANH_CONG_NOTE:
    "To ensure safety for customers, PVcomBank transfers your limit to 100 million / day. In case you wish to increase the limit, please contact 1900555592. You successfully recover your PIN code on this device. You absolutely do not provide username, password, PIN for Smart OTP protection and OTP to other people or websites that are not of PVcomBank or not affiliated with PVcomBank",
  SM_OTP_THONG_BAO_LOI_CHALLENGE_VALUE: "An error occurred, please try again",
  SM_OTP_THONG_BAO_QUEN_PIN: "Please visit the nearest branch to redeem your Smart OTP protection PIN.",
  SM_OTP_THONG_BAO_SMART_OTP: "Smart OTP",
  SM_OTP_THONG_BAO_THEM_FACE_THANH_CONG: "Face ID authentication completed successfully",
  SM_OTP_THONG_BAO_THEM_TOUCH_THANH_CONG: "Install Face ID authentication completed successfully.",
  SM_OTP_THONG_BAO_THIET_BI_DA_DK_SMART_ACC_KHAC:
    "The device is registering Smart OTP for another account. If you continue, the device will erase the old Smart OTP setting. Do you want to continue to register Smart OTP for this account?",
  SM_OTP_THONG_BAO_XOA_FACE_THANH_CONG: "Delete face ID authentication successfully completed",
  SM_OTP_THONG_BAO_XOA_TOUCH_THANH_CONG: "Delete Face ID authentication successfully completed.",
  SM_OTP_THONG_BAO_YEU_CAU_HOAN_THANH_KICH_HOAT_SMART:
    "You have registered for Smart OTP. Please perform the activation step to complete the process.",
  SM_OTP_THONG_TIN_GIAO_DICH: "Transaction information",
  SM_OTP_TITLE_CHUYEN_THIET_BI: "Change device",
  SM_OTP_TITLE_THONG_BAO_DANG_KY: "Register for smart otp",
  SM_OTP_TK_CHUA_DK_PHUONG_THUC_XAC_THUC: "Your account has not registered an authentication method",
  SM_OTP_USER: "Internet Banking username",
  SM_OTP_VUI_LONG_NHAP_MA_PIN: "Please enter the PIN",
  SM_OTP_XAC_NHAN: "Confirm",
  SM_OTP_XAC_THUC: "Validate OTP",
  SM_OTP_XAC_THUC_THANH_CONG: "Authentication successful",
  SM_OTP_XOA_FACE_ID: "Delete FaceID",
  SM_OTP_XOA_VAN_TAY: "Delete fingerprint",
  SM_OTP_NOTE_XAC_THUC_GIAO_DICH: "Enter Pin to verify transaction",
  SM_OTP_NOTE_LAY_MA_XAC_THUC: "Enter Pin to get OTP",
  SM_OTP_NOTE_XAC_THUC_GIAO_DICH_VAN_TAY: "Enter Pin code or verify via Fingerprint to verify transaction",
  SM_OTP_NOTE_LAY_MA_XAC_THUC_VAN_TAY: "Enter Pin code or verify via Fingerprint to get OTP",
  SM_OTP_NOTE_XAC_THUC_GIAO_DICH_FACEID: "Enter Pin code or authenticate via FaceID to authenticate transaction",
  SM_OTP_NOTE_LAY_MA_XAC_THUC_FACEID: "Enter Pin code or authenticate via FaceID to get OTP",
  SM_OTP_MA_OTP_TIEU_DE: "OTP code to confirm. OTP will expire later",
  SM_OTP_MA_OTP_TIME_COUNT_DOWN: "OTP will expire later",
  SM_OTP_MA_OTP_SMART_TIEU_DE: "OTP will expire later",
  SM_OTP_THONG_BAO_TRANS_LIT_SMART_NOT_REGIS: "If you change your limit, please register for Smart OTP authentication method",
  SM_OTP_THONG_BAO_TRANS_LIT_SMART_DEACTIVE: "If you change your limit, please activate Smart OTP authentication method",

  STEP_KHOI_TAO: "Initialization",
  STEP_XAC_NHAN: "Confirm",
  STEP_XAC_THUC: "Validate",
  STEP_KET_QUA: "Result",

  TOPUP_CHUA_DANG_KY_GIAO_DICH_NAO: "You have not had phone number for registering automatic topup.",
  TOPUP_CHUC_NANG_NAP_TIEN: "Topup function",
  TOPUP_CHON_DICH_VU: "Select service",
  TOPUP_CHON_NHA_CUNG_CAP: "Select provider",
  TOPUP_DAI_LY_VE_MAY_BAY: "Airline ticket agency topup",
  TOPUP_DICH_VU: "Services",
  TOPUP_DV_GIAO_THONG: "Traffic service",
  TOPUP_HO_TEN: "Full name",
  TOPUP_MA_NGUOI_DUNG: "Customer code",
  TOPUP_MENH_GIA: "Denomination",
  TOPUP_NAP_TIEN_DIEN_THOAI: "Topup ",
  TOPUP_NAP_TIEN_THANH_CONG: "Topup {so_tien} successfully to phone number {so_dien_thoai}",
  TOPUP_NHA_CUNG_CAP: "Provider",
  TOPUP_NOTE_GIAO_DICH_NHANH_THU_HUONG: "To faster trading and no need to remember the information?",
  TOPUP_QUY_KHACH_MUON_HUY_GIAO_DICH: "Do you want to cancel this transaction?",
  TOPUP_SO_DIEN_THOAI: "Phone number",
  TOPUP_SO_DIEN_THOAI_KHONG_HOP_LE: "The phone number is not correct. Please check again",
  TOPUP_SO_DIEN_THOAI_TAI_KHOAN_DICH_VU: "Phone number/ Account",
  TOPUP_SO_TIEN: "Amount",
  TOPUP_SO_TIEN_NAP: "Amount",
  TOPUP_TAI_KHOAN_GAME: "Game account",
  TOPUP_TAI_KHOAN_NGUON: "Source account",
  TOPUP_TAI_KHOAN_THANH_TOAN: "Payment account",
  TOPUP_THONG_BAO_TRANG_THAI_TAI_KHOAN: "Payment account is inactive. Please contact the nearest branch to support.",
  TOPUP_VI_DIEN_TU: "Electronic wallet",
  TOPUP_VUI_LONG_CHON_DICH_VU: "Please select a service",
  TOPUP_VUI_LONG_CHON_MENH_GIA: "Please choose a denomination",
  TOPUP_VUI_LONG_NHAP_SO_TIEN: "Please enter the amount",
  TOPUP_VUI_LONG_CHON_NHA_CUNG_CAP: "Please select a provider",
  TOPUP_VUI_LONG_NHAP_SO_DIEN_THOAI: "Please enter phone number",
  TOPUP_VUI_LONG_NHAP_SO_DIEN_THOAI_SO_TAI_KHOAN: "Please enter phone number/account",

  TRANFER_247_KIEU: "Type",
  TRANFER_BEN_CHIU_PHI: "Charged",
  TRANFER_BEN_CHUYEN: "Transferor",
  TRANFER_BEN_NHAN: "Receiver",
  TRANFER_CHI_NHANH: "Branch",
  TRANFER_CHI_NHANH_KHAC: "Branch other",
  TRANFER_CHON_CHI_NHANH: "Select a branch",
  TRANFER_CHON_CONG_TY_CHUNG_KHOAN: "Select a stock company",
  TRANFER_CHON_NGAY_THANH_TOAN: "Select payment date",
  TRANFER_CHON_NGAN_HANG: "Select bank",
  TRANFER_CHON_KHU_VUC: "Select area",
  TRANFER_CHON_PHUONG_THUC_CHUYEN_TIEN: "Select tranfer method",
  TRANFER_CHON_PHUONG_THUC_THANH_TOAN: "Select payment method",
  TRANFER_CHON_TAI_KHOAN_NHAN: "Select receivable account",
  TRANFER_CHUNG_KHOAN: "PSI",
  TRANFER_CHUYEN_TIEN: "Transfer",
  TRANFER_DESCRIPTION_CHUYEN_TIEN: "Transfer",
  TRANFER_DESCRIPTION_CHUYEN_TIEN_CHUNG_KHOAN: "Nop tien vao tai khoan",
  TRANFER_CHUYEN_TIEN_CHUNG_KHOAN: "Transfer to PSI account",
  TRANFER_CHUYEN_TIEN_NGOAI_PVCOMBANK: "Interbank Transfer",
  TRANFER_CHUYEN_TIEN_NHANH_247: "Quick transfer NAPAS 24/7",
  TRANFER_CHUYEN_TIEN_TRONG_PVCOMBANK: "Intrabank transfer",
  TRANFER_CHU_TAI_KHOAN: "Account owner name",
  TRANFER_CONG_TY_CHUNG_KHOAN: "Stock company",
  TRANFER_CUNG_CHU_TAI_KHOAN: "The same CIF",
  TRANFER_DICH_VU: "Service",
  TRANFER_DICH_VU_CHUNG_KHOAN: "PSI services",
  TRANFER_KHAC_CHU_TAI_KHOAN: "The other CIF",
  TRANFER_KHU_VUC: "Area",
  TRANFER_NGAN_HANG: "Bank",
  TRANFER_NGOAI_PV: "Internal Transfer",
  TRANFER_NHANH_247: "Received immediately",
  TRANFER_NHA_CUNG_CAP: "Provider",
  TRANFER_NOI_DUNG: "Content",
  TRANFER_NOI_DUNG_CHUYEN_TIEN: "Content",
  TRANFER_NOI_DUNG_CHUYEN_TIEN_KHONG_HOP_LE: "Please do not enter account number accented Vietnamese and containing special characters",
  TRANFER_NOTE_CHUYEN_NHANH_THU_HUONG: "To transfer money faster and do not need to remember the information?",
  TRANFER_QUY_KHACH_KHONG_CO_TAI_THANH_TOAN: "You cannot make this transaction because you only have a valid account.",
  TRANFER_QUY_KHACH_MUON_HUY_GIAO_DICH: "Do you want to cancel this transaction?",
  TRANFER_SO_DIEN_THOAI: "Phone number",
  TRANFER_SO_DIEN_THOAI_SO_TAI_KHOAN: "Phone number / Account number",
  TRANFER_SO_TAI_KHOAN: "Account number",
  TRANFER_SO_TAI_KHOAN_CHUNG_KHOAN: "PSI account number",
  TRANFER_SO_TAI_KHOAN_HOAC_DIEN_THOAI_KHONG_DUNG: "Receivable account does not exist",
  TRANFER_SO_TAI_KHOAN_KHONG_DUNG: "Receivable account does not exist",
  TRANFER_SO_THE_ATM: "ATM card number",
  TRANFER_SO_TIEN: "Amount",
  TRANFER_SO_TIEN_CON_LAI: "The remainder amount",
  TRANFER_SO_TIEN_KHONG_DUOC_VUOT_TREN_LAN: "Transaction amount cannot exceed {amount} / 1 transaction",
  TRANFER_TAI_KHOAN: "Account",
  TRANFER_TAI_KHOAN_CHUYEN: "Transfer account",
  TRANFER_TAI_KHOAN_NGUON: "Source account",
  TRANFER_TAI_KHOAN_NHAN: "Receivable account",
  TRANFER_TAI_NGAN_HANG: "Bank",
  TRANFER_TEN_CHI_NHANH: "Branch name",
  TRANFER_TEN_TAI_KHOAN: "Account name",
  TRANFER_THANH_TOAN_CUOC_VIEN_THONG: "Payment of telecommunications charges",
  TRANFER_THONG_BAO_CHUA_NHAP_NOI_DUNG: "Please enter transaction content.",
  TRANFER_THONG_BAO_CHUYEN_KHOAN_THANH_CONG: "Transfer  {} successful to account {}",
  TRANFER_THONG_BAO_NHAP_THIEU_CONG_TY_CHUNG_KHOAN: "Please select stock company.",
  TRANFER_THONG_BAO_NHAP_THIEU_NGAN_HANG: "Please select bank name",
  TRANFER_THONG_BAO_NHAP_THIEU_SO_TIEN: "Please enter amount.",
  TRANFER_THONG_BAO_NHAP_THIEU_TAI_KHOAN: "Please enter receivable account",
  TRANFER_THONG_BAO_NHAP_THIEU_TAI_KHOAN_CHUNG_KHOAN: "Please enter securities account number.",
  TRANFER_THONG_BAO_NOI_DUNG_KHONG_DE_TRONG: "Content cannot be blank.",
  TRANFER_THONG_BAO_TRANG_THAI_TAI_KHOAN_CHUYEN: "The transfer account is inactive. Please contact the nearest branch for support.",
  TRANFER_THONG_BAO_TRANG_THAI_TAI_KHOAN_DICH: "The receiver account is inactive. Please contact the nearest branch for support.",
  TRANFER_TIM_CHI_NHANH: "Search by branch name",
  TRANFER_TIM_KHU_VUC: "Search by area",
  TRANFER_TIM_NGAN_HANG: "Search by bank name",
  TRANFER_TRONG_PV: "Intrabank Transfer",
  TRANFER_VUI_LONG_CHON_CHI_NHANH: "Please select a branch.",
  TRANFER_VUI_LONG_CHON_CHI_NHANH_CONG_TY_CHUNG_KHOAN: "Please select a branch.",
  TRANFER_VUI_LONG_CHON_KHU_VUC: "Please select an area .",
  TRANFER_VUI_LONG_CHON_NGAN_HANG: "Please select a bank",
  TRANFER_VUI_LONG_KHONG_NHAP_TAI_KHOAN_CO_DAU_VA_KI_TU:
    "Please do not enter content in Vietnamese with accents and special characters except dash and dot",
  TRANFER_VUI_LONG_NHAP_CHI_NHANH_KHAC: "Please select other branch.",
  TRANFER_VUI_LONG_NHAP_DAY_DU_THONG_TIN: "Please enter full information",
  TRANFER_VUI_LONG_NHAP_DU_THONG_TIN: "Please enter full information.",
  TRANFER_VUI_LONG_NHAP_SO_TAI_KHOAN_KHONG_CO_DAU: "Please do not enter account number in Vietnamese with accents and special characters",
  TRANFER_VUI_LONG_NHAP_SO_TAI_KHOAN_NHAN: "Please enter receivable account",
  TRANFER_VUI_LONG_NHAP_SO_THE_ATM: "Please enter ATM card number",
  TRANFER_VUI_LONG_NHAP_SO_TIEN: "Please enter amount",
  TRANFER_VUI_LONG_NHAP_TEN_CHU_TAI_KHOAN_CONG_TY_CHUNG_KHOAN: "Please enter fullname of securities account owner",
  TRANFER_VUI_LONG_NHAP_TEN_TAI_KHOAN: "Please enter account name",
  TRANFER_VUI_LONG_NHAP_TEN_TAI_KHOAN_KHONG_CO_DAU: "Please do not enter account name in Vietnamese with accents and special characters",
  TRANFER_CHUYEN_HAN_MUC_GD: "Change transaction limit package",
  TRANFER_GOI_HAN_MUC_HIEN_TAI: "Current quota package",
  TRANFER_CHON_GOI_HAN_MUC_MOI: "Select new quota package",
  TRANFER_KHUYEN_CAO: "Recommended",
  TRANFER_NOTE_CHANGE_TRANS_LIMIT:
    "Increase your limit only in case of real need. To minimize risks, in case of not using up the High Limit Package, please switch to lower limit packages.",
  TRANFER_DIEU_KHOAN_BAO_MAT: "Terms and conditions",
  TRANFER_NOI_DUNG_DIEU_KHOAN_BAO_MAT: "",
  TRANFER_TOI_DONG_Y: "I agree",
  TRANFER_CHUYEN_HAN_MUC_THANH_CONG:
    "You have successfully changed your limit, your new limit is {limit}. If you need assistance please contact Branch / Transaction Office or Hotline {hotline}.",
  TRANFER_CHUYEN_TIEN_NOI_BO: "Intrabank Transfer",
  TRANFER_STK_THU_HUONG: "Beneficiary account number",
  TRANFER_TEN_NGUOI_THU_HUONG: "Name of beneficiary",
  TRANFER_THONG_BAO_TRUNG_TK_NGUON: "The receiving and transferring accounts are duplicated",
  TRANFER_LOI_TAI_KHOAN: "Invalid account",
  TRANFER_CHUYEN_TIEN_TU_THIEN: "Transfer charity",
  TRANFER_CHARITY_DON_VI_TIEP_NHAN: "Receiving unit",
  TRANFER_CHARITY_TEN_NGUOI_UNG_HO: "Full name of supporter",
  TRANFER_CHARITY_DIA_CHI: "Address of Supporter",
  TRANFER_CHARITY_SO_DIEN_THOAI: "Supporter phone number",
  TRANFER_CHARITY_HOAN_CANH_UNG_HO: "Supporting content",

  TRANSACTION_DA_GUI_YEU_CAU: "Sent request",
  TRANSACTION_DA_TRA_LOI_YEU_CAU: "Answered",
  TRANSACTION_EMAIL: "Email (not required)",
  TRANSACTION_GUI_YEU_CAU: "Send request",
  TRANSACTION_HUY: "Cancel",
  TRANSACTION_ID_TRA_SOAT: "ID transactions",
  TRANSACTION_KET_QUA_TRA_SOAT: "Dispute results",
  TRANSACTION_KET_QUA_XU_LY: "Results of processing",
  TRANSACTION_KET_THUC: "Finish",
  TRANSACTION_KHONG_CO_YEU_CAU_TRA_SOAT: "There is no dispute transaction request.",
  TRANSACTION_LICH_SU_TRA_SOAT: "History of dispute transaction",
  TRANSACTION_LY_DO_TRA_SOAT: "Reason for dispute",
  TRANSACTION_MO_TA: "Description",
  TRANSACTION_NGAY_YEU_CAU: "Request date",
  TRANSACTION_NOI_DUNG: "Content",
  TRANSACTION_NOI_DUNG_TRA_LOI: "Reply content",
  TRANSACTION_SO_BUT_TOAN: "Number of entries",
  TRANSACTION_SO_DIEN_THOAI: "Phone number",
  TRANSACTION_SO_DIEN_THOAI_KHONG_HOP_LE: "Invalid phone number. Please try again.",
  TRANSACTION_SO_TIEN: "Amount",
  TRANSACTION_THOI_GIAN_GIAO_DICH: "Transaction time",
  TRANSACTION_THONG_BAO_EMAIL_KHONG_HOP_LE: "Invalid email. Please try again",
  TRANSACTION_THONG_BAO_HOI_HUY_TRA_SOAT: "Do want to cancel this dispute transaction request?",
  TRANSACTION_THONG_BAO_KHONG_CO_LY_DO: "No reason transactions",
  TRANSACTION_TIM_KIEM: "Search",
  TRANSACTION_TRANG_THAI: "Status",
  TRANSACTION_TRA_SOAT_GIAO_DICH: "Dispute transactions",
  TRANSACTION_TRA_SOAT_GIAO_DICH_KHAC: "Dispute other transaction",
  TRANSACTION_TRUY_VAN: "Inquiry",
  TRANSACTION_VUI_LONG_NHAP_LY_DO_TRA_SOAT: "Please enter reason of dispute transactions.",
  TRANSACTION_VUI_LONG_NHAP_SO_DIEN_THOAI: "Please enter phone number.",
  TRANSACTION_YEU_CAU_TRA_SOAT_THANH_CONG:
    "Your dispute transactions has been recorded. PVcomBank will respond to the results as soon as possible. Thank you!",

  dieu_khoan_su_dung:
    "<p align='center'><span style='color: #0070c0;'><strong>ĐIỀU KHOẢN</strong></span></span><span style='color: #0070c0;'><strong> DỊCH VỤ NGÂN HÀNG ĐIỆN TỬ</strong></span></span></p>\r\n<p align='justify'><br></p>\r\n<p align='justify'><span style=' font-weight: 700;'>Điều 1. Phạm vi cung cấp dịch vụ</span></p>\r\n<p align='justify'>1. PVcomBank (NH) cung cấp cho khách hàng (KH) các dịch vụ Ngân hàng điện tử (NHĐT) bao gồm: Dịch vụ Ngân hàng trực tuyến (Online Banking/Mobile Banking), dịch vụ Ngân hàng di động (SMS Banking), dịch vụ Thanh toán trực tuyến (eComerce) và các dịch vụ khác mà PVcomBank cung cấp trong từng thời kỳ (sau đây gọi tắt là “Dịch vụ”).</span><br></p>\r\n<p align='justify'>2. Tuỳ từng thời kỳ, NH có quyền thay đổi, bổ sung các chức năng của từng gói dịch vụ và sẽ thông báo cho KH thông qua website www.pvcombank.com.vn.</span></p>\r\n<p align='justify'><br></p>\r\n<p align='justify'><span style=' font-weight: 700;'>Điều 2. Quyền và nghĩa vụ của khách hàng</span><br></p>\r\n<p align='justify'>1. Sử dụng các dịch vụ NHĐT do NH cung cấp đúng mục đích và hợp pháp; đảm bảo không sử dụng các dịch vụ/sản phẩm đã đăng ký tại Ngân hàng để phục vụ cho các hoạt động kinh doanh tiền ảo, đánh bạc trực tuyến và các mục đích bất hợp pháp khác theo quy định của pháp luật.</span><br></p>\r\n<p align='justify'>2. Tuân thủ các quy định của NH về đăng ký, sử dụng dịch vụ và các hướng dẫn khác.</span><br></p>\r\n<p align='justify'>3. KH phải thực hiện đúng Hướng dẫn sử dụng dịch vụ do NH ban hành và đăng tải trên website của NH. Trường hợp có sự thay đổi về HDSD dịch vụ, KH thừa nhận và đồng ý việc NH sẽ đăng tải lên website mà không cần thêm bất kỳ sự thông báo nào khác từ NH.</span><br></p>\r\n<p align='justify'>4. KH sử dụng dịch vụ theo hạn mức đăng ký với NH (nếu có) hoặc theo quy định của NH trong từng thời kỳ.</span><br></p>\r\n<p align='justify'>5. Bảo mật các thông tin về tên truy cập,mật khẩu truy cập và thiết bị bảo mật.</span><br></p>\r\n<p align='justify'>6. Hoàn toàn chịu mọi trách nhiệm và thiệt hại có thể xảy ra do việc sử dụng trái phép của người không có thẩm quyền truy cập.</span><br></p>\r\n<p align='justify'>7. KH tự đảm bảo quá trình thực hiện giao dịch chính xác và đầy đủ.</span><br></p>\r\n<p align='justify'>8. Thông báo kịp thời cho NH trong trường hợp tên truy cập, mật khẩu truy cập bị lộ hoặc thiết bị bảo mật bị thất lạc.</span><br></p>\r\n<p align='justify'>9. Thông báo ngay cho NH bất kỳ sự thay đổi gì liên quan đến địa chỉ thư điện tử, số điện thoại di động đã đăng ký của KH. Trừ khi nhận được thông báo thay đổi của KH, NH sẽ tiếp tục cung cấp dịch vụ qua địa chỉ email hoặc số điện thoại di động mà KH đã đăng ký.</span><br></p>\r\n<p align='justify'>10. Trường hợp KH sử dụng dịch vụ để thanh toán cho các Nhà cung ứng dịch vụ (NCƯ), KH chịu mọi trách nhiệm đối với giao dịch cung cấp không chính xác mã dịch vụ, mã thanh toán và các thông tin khác; tự giải quyết các tranh chấp liên quan đến việc cung ứng dịch vụ của NCƯ về số tiền thanh toán, mã thanh toán, thời điểm thanh toán; chịu trách nhiệm về các giao dịch được gửi nhiều lần và các vấn đề khác giữa KH và NCƯ trong mọi thời điểm.</span><br></p>\r\n<p align='justify'>11. Có quyền chấm dứt việc sử dụng các dịch vụ do NH cung cấp bất cứ lúc nào sau khi thông báo bằng văn bản cho NH về việc đóng dịch vụ.</span><br></p>\r\n<p align='justify'>12. Tuân thủ quy định về việc nộp phí dịch vụ của NH.</span><br></p>\r\n<p align='justify'>13. Hoàn toàn chịu mọi trách nhiệm liên quan tới việc sử dụng Số điện thoại di động làm thông tin để đăng ký mở hồ sơ khách hàng, thay đổi thông tin hồ sơ khách hàng và đăng ký sử dụng các dịch vụ tại Ngân hàng.</span><br></p>\r\n<p align='justify'>14. Thực hiện ngay việc đăng ký thay đổi số điện thoại di động phục vụ cho việc sử dụng các dịch vụ/sản phẩm tại Ngân hàng trong trường hợp có bất kỳ sự thay đổi có liên quan đến số điện thoại di động đã đăng ký.</span><br></p>\r\n<p align='justify'><br></p>\r\n<p align='justify'><span style=' font-weight: 700;'>Điều 3. Quyền và nghĩa vụ của NH</span></p>\r\n<p align='justify'>1. Cung cấp dịch vụ và thực hiện các giao dịch điện tử của KH khi nhận đúng các thông tin khai báo như tên truy cập, mật khẩu truy cập, mật khẩu của thiết bị bảo mật.</span><br></p>\r\n<p align='justify'>2. Đảm bảo hệ thống dịch vụ vận hành ổn định, an toàn và tuân thủ các quy dịnh của pháp luật liên quan đến việc cung ứng dịch vụ.</span><br></p>\r\n<p align='justify'>3. NH không chịu trách nhiệm đối với những thiệt hại, rủi ro có thể xảy ra trong các trường hợp sau:</span><br></p>\r\n<p align='justify'>a. KH để lộ tên truy cập, mật khẩu truy cập, mã xác thực OTP còn hiệu lực, thất lạc thiết bị bảo mật hoặc các thông tin khác dẫn đến việc người khác có thể dùng các thông tin đó để sử dụng dịch vụ trái phép; Người sử dụng dịch vụ phải là KH, hoặc là người được KH ủy quyền hoặc cho phép sử dụng tên truy cập, mật khẩu truy cập để sử dụng dịch vụ;</span><br></p>\r\n<p align='justify'>b. Ngân hàng được miễn trừ hoàn toàn mọi trách nhiệm đối với các thiệt hại phát sinh khi KH không đăng ký thay đổi Số điện thoại di động để thực hiện giao dịch tại Ngân hàng.</span><br></p>\r\n<p align='justify'>c. Các trường hợp bất khả kháng nằm ngoài sự kiểm soát của ngân hàng và KH theo quy định của pháp luật.</span><br></p>\r\n<p align='justify'>4. NH có quyền tự động trích từ tài khoản tiền gửi của KH để thu phí dịch vụ theo quy định.</span><br></p>\r\n<p align='justify'>5. NH có quyền thay đổi, ngừng hoặc chấm dứt việc cung ứng dịch vụ cho KH bất kỳ lúc nào mà không cần sự đồng ý của KH trong các trường hợp:</span><br></p>\r\n<p align='justify'>a. Việc sử dụng dịch vụ của KH có thể gây ảnh hưởng tới tính an toàn, bảo mật của hệ thống của NH;</span><br></p>\r\n<p align='justify'>b. NH ngừng vận hành hoặc nâng cấp hệ thống trong một thời gian nhất định;</span><br></p>\r\n<p align='justify'>c. Các trường hợp bất khả kháng theo quy định của pháp luật.</span><br></p>\r\n<p align='justify'>6. NH có thể từ chối không thực hiện lệnh thanh toán của KH trong trường hợp tài khoản của KH không đủ số dư; hoặc do tài khoản của KH đã đóng hoặc không hợp lệ; hoặc do nhà cung cấp dịch vụ không cho phép thực hiện thanh toán hóa đơn bằng phương tiện điện tử, và trong những trường hợp như vậy, NH sẽ gửi thông báo cho KH.</span><br></p>\r\n<p align='justify'>7. NH không chấp nhận việc hủy bỏ lệnh thanh toán mà KH đã thực hiện thành công. Tất cả các lệnh thanh toán do KH đưa ra khi sử dụng dịch vụ được coi là không hủy ngang, cho dù lệnh thanh toán này do KH hay một người khác được hiểu là KH thực hiện. Việc hủy bỏ phải từ phía nhà cung cấp dịch vụ và phải được sự đồng ý của NH.</span><br></p>\r\n<p align='justify'>8. NH được quyền tự động trích nợ tài khoản KH sử dụng trong Dịch vụ để thanh toán cho các hóa đơn mà KH mua hàng hóa hoặc sử dụng dịch vụ với các nhà cung cấp mà KH tham gia. Việc thanh toán này có thể được thực hiện theo yêu cầu của KH hoặc theo yêu cầu của chính nhà cung cấp dịch vụ.</span></p>\r\n<p align='justify'><br></p>\r\n<p align='justify'><span style=' font-weight: 700;'>Điều 4. Phí sử dụng dịch vụ</span><br></p>\r\n<p align='justify'>1. Phí dịch vụ được áp dụng theo biểu phí do NH ban hành và có thể được thay đổi cho phù hợp với từng thời kỳ.</span><br></p>\r\n<p align='justify'>2. KH ủy quyền cho NH được quyền tự động trích nợ phí sử dụng Dịch vụ trên bất kỳ tài khoản nào mở tại NH để thanh toán tiền phí sử dụng Dịch vụ này.</span><br></p>\r\n<p align='justify'><br></span></p>\r\n<p align='justify'><span style=' font-weight: bold;'>Điều 5. Các quy định khác</span><br></p>\r\n<p align='justify'>1. Các thiết kế, biểu tượng, hình ảnh và các thông tin khác do NH cung cấp qua các dịch vụ Ngân hàng điện tử là tài sản thuộc sở hữu trí tuệ của NH. Mọi sự sao chép, thay thế, sửa chữa mà không được sự chấp thuận của NH đều bị coi là bất hợp pháp.</span><br></p>\r\n<p align='justify'>2. Những vấn đề chưa được nêu trong quy định này được thực hiện theo các quy định của pháp luật.</span><br></p>\r\n<p align='justify'>3. Bằng việc ký vào bản đăng ký này, các bên đã thống nhất và chấp nhận các điều khoản đã quy định. KH cam kết đã đọc, hiểu rõ và tuân thủ đúng, đầy đủ những điều khoản, điều kiện như trên và các quy định liên quan của pháp luật.</span><br></p>",
  note_password_rule:
    "<p><span style='color: rgb(51, 51, 51); font-family: Arial, sans-serif;'>Note: A valid password must respone the following criteria:</span></p><p><span style='color: rgb(51, 51, 51); font-family: Arial, sans-serif;'>-At least 06 characters.</span></p><p><span style='color: rgb(51, 51, 51); font-family: Arial, sans-serif;'>-Including letters and numbers, uppercase and lowercase letters or special characters.</span></p><p><span style='color: rgb(51, 51, 51); font-family: Arial, sans-serif;'>-Do not coincises with the login name.</span></p><p><span style='color: rgb(51, 51, 51); font-family: Arial, sans-serif;'>-Do not coincises with the old password.</span></p>",
  ONLINE_LOAN_MORTGAGE_ERROR_MAX_SELECTED: "Please selected maximum 3",
  ONLINE_LOAN_SELECT_SAVING_ACCOUNT_TITLE: "Please select saving account",
  ONLINE_LOAN_CREATE_TITLE: "Create new loan",
  ONLINE_LOAN_MORTGAGE_SAVING_TITLE: "Online loan mortgage",
};
